


  jQuery(document).ready(function() {
	console.log("test header");
    jQuery('.tool-tip__close').attr('aria-label', 'Close tooltip');
    jQuery('.price-range__input-min').attr('aria-label', 'Minimum price');
    jQuery('.price-range__input-max').attr('aria-label', 'Maximum price');
    jQuery('th[scope="row"]:empty').text('Details');
    jQuery('#shopify-section-template--27312257466688__main .rte img:not([alt])')
      .attr('alt', 'Yield information');


   });


/* ==========================================================================
   American Bench Craft – jQuery accessibility fixes (v2, merged after Retest 2, 29-Sep-2026)
   REPLACES the previous ada-pro.js content entirely
   Staging theme: 188265726272 (Impulse-based)
   --------------------------------------------------------------------------
   HOW TO USE
   • Load after jQuery (e.g. assets/abc-a11y-fixes.js, included in theme.liquid
     just before </body>).
   • Each "BUG xxx" block is fully self-contained (its own helpers, no shared
     globals), so you can comment out / paste / test any block on its own.
   • Every block logs "[A11Y-xxx]" to the console. Filter the console by
     "A11Y-" to see which fixes ran and on how many elements.
   • Blocks marked "VERIFY" touch 3rd-party or theme-internal behaviour that
     could not be inspected fully from the front end. Test them first.
   • Bugs NOT covered by code (content or cross-origin) are listed at the end.
   ========================================================================== */


/* ==========================================================================
   ESC-GUARD (NEW – needed by BUG 011 and BUG 055)
   Root cause found in retest: the theme's global Escape handler (search
   close) runs on EVERY Escape press, even when search is closed, and moves
   focus to the header Search button. That steals focus from the cart drawer
   and the Junip modal. This puts focus back where it was if the theme moved
   it to Search while the search dialog was not open.
   ========================================================================== */
jQuery(function ($) {
  var last = null, until = 0;
  // Escape pressed while search is CLOSED -> watch for the theme jumping focus to Search
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    until = document.querySelector('.js-search-header[aria-expanded="true"]') ? 0 : Date.now() + 800;
  }, true);
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t.classList && t.classList.contains('js-search-header')) {
      if (Date.now() < until && last && last !== t && document.body.contains(last) && last.getClientRects().length) {
        var back = last;
        setTimeout(function () { back.focus(); console.log('[A11Y-ESC] undid theme focus jump to Search'); }, 0);
      }
      return;
    }
    last = t;
  }, true);
});


/* ==========================================================================
   BUG 004 – Search dialog: no accessible name, focus not trapped
   Root cause: .site-header__search has role="dialog" aria-modal="true" but no
   name, and nothing stops Tab/Shift+Tab leaving it.
   ========================================================================== */
jQuery(function ($) {
  var $dlg = $('.site-header__search[role="dialog"]');
  if (!$dlg.length) return;

  $dlg.attr('aria-label', 'Search');

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  $dlg.on('keydown.a11y004', function (e) {
    if (e.key !== 'Tab') return;
    var $f = $dlg.find(FOCUSABLE).filter(':visible');
    if (!$f.length) return;
    var first = $f[0], last = $f[$f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === $dlg[0])) {
      e.preventDefault(); last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault(); first.focus();
    }
  });
  console.log('[A11Y-004] search dialog named + focus trap attached');
});


/* ==========================================================================
   BUG 007 – Header Cart control does not say it opens a dialog
   ========================================================================== */
jQuery(function ($) {
  var $cart = $('.js-drawer-open-cart');
  $cart.attr('aria-haspopup', 'dialog');
  console.log('[A11Y-007] aria-haspopup="dialog" added to', $cart.length, 'cart control(s)');
});


/* ==========================================================================
   BUG 008 (+105, covers 042) – Focus does not move into the cart drawer
   Root cause: 3rd-party upez drawer slides in but never moves focus. This
   watches for the drawer becoming visible (from Cart icon OR Add to Cart)
   and moves focus into it.
   ========================================================================== */
jQuery(function ($) {
  var wasOpen = false;
  function drawer() { return document.querySelector('.upez--inner-drawer-container'); }
  function isOpen() {
    var d = drawer(); if (!d) return false;
    var r = d.getBoundingClientRect();
    return r.width > 0 && r.left < window.innerWidth - 10;
  }
  setInterval(function () {
    var open = isOpen();
    if (open && !wasOpen) {
      var d = drawer();
      if (!d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1');
      // Prefer the Close button if Bug 009 made it focusable, otherwise the drawer itself
      var close = d.parentNode.querySelector('.upez--close-button[tabindex="0"]') || document.querySelector('.upez--close-button[tabindex="0"]');
      setTimeout(function () { (close || d).focus(); }, 150);
      console.log('[A11Y-008] cart drawer opened – focus moved into drawer');
    }
    wasOpen = open;
  }, 250);
});


/* ==========================================================================
   BUG 009 – Cart drawer Close (X) is a <div>, not focusable, no name
   ========================================================================== */
jQuery(function ($) {
  function fix() {
    $('.upez--close-button').each(function () {
      var $b = $(this);
      if ($b.attr('data-a11y009')) return;
      $b.attr({ role: 'button', tabindex: '0', 'aria-label': 'Close cart', 'data-a11y009': '1' });
      $b.find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' });
      $b.on('keydown.a11y009', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
      });
    });
  }
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(fix).observe(root, { childList: true, subtree: true });
  console.log('[A11Y-009] close button fix active');
});


/* ==========================================================================
   BUG 010 (+105) – Cart drawer has no dialog semantics, focus not contained
   ========================================================================== */
jQuery(function ($) {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function fix() {
    var $d = $('.upez--inner-drawer-container');
    if (!$d.length || $d.attr('data-a11y010')) return;
    $d.attr({ role: 'dialog', 'aria-modal': 'true', 'aria-label': 'Shopping cart', 'data-a11y010': '1' });
    $d.on('keydown.a11y010', function (e) {
      if (e.key !== 'Tab') return;
      // include the close button, which upez renders as a sibling in some layouts
      var $f = $d.find(FOCUSABLE).add($('.upez--close-button[tabindex="0"]')).filter(':visible');
      if (!$f.length) return;
      var first = $f[0], last = $f[$f.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement === $d[0])) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    console.log('[A11Y-010] cart drawer given role=dialog + focus trap');
  }
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(fix).observe(root, { childList: true, subtree: true });
});


/* ==========================================================================
   CART-INERT (NEW – fixes regression reported after Retest 3)
   Symptom: after tabbing past the footer, the cart drawer slides into view
   with no dark backdrop, and neither Escape nor the X closes it.
   Root cause: upez hides the closed drawer only with transform:translateX,
   and BUG 009/044/047 made its controls focusable. Tabbing past the footer
   focuses "Close cart" inside the CLOSED drawer; the browser scrolls the
   drawer's overflow:hidden wrapper to reveal it (scrollLeft 450) while upez
   still thinks it is closed, so Close/Escape do nothing.
   Fix: make the drawer inert while closed, undo any forced scroll, and
   block focus from entering it while closed. Verified live.
   ========================================================================== */
jQuery(function ($) {
  function inner() { return document.querySelector('.upez--inner-drawer-container'); }
  function isOpen(el) {
    try { var tx = new DOMMatrix(getComputedStyle(el).transform).m41; return tx < el.offsetWidth - 10; }
    catch (e) { return false; }
  }
  function sync() {
    var el = inner(); if (!el) return;
    var root = document.getElementById('upezCartContainer') || el;
    if (isOpen(el)) {
      if (root.hasAttribute('inert')) root.removeAttribute('inert');
    } else {
      if (!root.hasAttribute('inert')) root.setAttribute('inert', '');
      if (el.parentElement && el.parentElement.scrollLeft) el.parentElement.scrollLeft = 0;
    }
  }
  sync();
  setInterval(sync, 100);
  var el = inner();
  if (el) new MutationObserver(sync).observe(el, { attributes: true, attributeFilter: ['style', 'class'] });
  document.addEventListener('focusin', function (e) {
    var el = inner(), root = document.getElementById('upezCartContainer');
    if (el && root && root.contains(e.target) && !isOpen(el)) {
      e.target.blur();
      el.parentElement.scrollLeft = 0;
      console.log('[A11Y-CART-INERT] blocked focus entering the closed cart drawer');
    }
  }, true);
  console.log('[A11Y-CART-INERT] closed cart drawer kept inert');
});


/* ==========================================================================
   BUG 011 – Focus not returned to Cart / Add to Cart after drawer closes
   Fix vs v1: restores unconditionally (the theme's Escape handler had
   already moved focus to Search, so the "only if body" check never passed).
   ========================================================================== */
jQuery(function ($) {
  var lastTrigger = null, wasOpen = false;
  $(document).on('click.a11y011 keydown.a11y011', '.js-drawer-open-cart, [data-add-to-cart], button[name="add"]', function () {
    lastTrigger = this;
  });
  function isOpen() {
    var d = document.querySelector('.upez--inner-drawer-container'); if (!d) return false;
    var r = d.getBoundingClientRect(); return r.width > 0 && r.left < window.innerWidth - 10;
  }
  setInterval(function () {
    var open = isOpen();
    if (!open && wasOpen && lastTrigger && document.body.contains(lastTrigger)) {
      var t = lastTrigger;
      setTimeout(function () { t.focus(); console.log('[A11Y-011] focus returned to', t); }, 60);
    }
    wasOpen = open;
  }, 200);
});


/* ==========================================================================
   BUG 019 (+036) – Junip rating still inside the card link
   Fix vs v1: moves the outer <span class="junip-product-summary"> placeholder
   (present at DOM ready; Junip fills it later) instead of the star container.
   ========================================================================== */
jQuery(function ($) {
  var n = 0;
  $('.grid-product__link').each(function () {
    var $link = $(this);
    var $move = $link.find('.grid-product__price').add($link.find('.junip-product-summary').first());
    if (!$move.length) return;
    var $wrap = $link.next('.grid-product__a11y-meta');
    if (!$wrap.length) $wrap = $('<div class="grid-product__a11y-meta"></div>').insertAfter($link);
    $move.appendTo($wrap);      // keeps order: price, then rating
    n++;
  });
  console.log('[A11Y-019] price/rating moved outside card link on', n, 'cards');
});


/* ==========================================================================
   BUG 020 (+037) – Card prices have no "Regular price"/"Sale price" label
   ========================================================================== */
jQuery(function ($) {
  var n = 0;
  $('.grid-product__price').each(function () {
    var $p = $(this);
    if ($p.attr('data-a11y020')) return;
    var $orig = $p.find('s, del, .grid-product__price--original');
    if ($orig.length) {
      $orig.first().prepend('<span class="visually-hidden">Regular price:</span>');
      $p.prepend('<span class="visually-hidden">Sale price:</span>');
    } else {
      $p.prepend('<span class="visually-hidden">Regular price:</span>');
    }
    $p.attr('data-a11y020', '1'); n++;
  });
  console.log('[A11Y-020] price labels added to', n, 'prices');
});


/* ==========================================================================
   BUG 021 – Colour swatches are javascript:void(0) links, no selected state
   ========================================================================== */
jQuery(function ($) {
  var $sw = $('.color-swatch[href^="javascript"]');
  $sw.each(function () {
    $(this).attr({ role: 'button', 'aria-pressed': $(this).hasClass('active') ? 'true' : 'false' });
  });
  // Space must activate a role=button (links only respond to Enter)
  $(document).on('keydown.a11y021', '.color-swatch[role="button"]', function (e) {
    if (e.key === ' ') { e.preventDefault(); this.click(); }
  });
  // keep aria-pressed in sync after the theme's updateCollectionSwitcherImage() runs
  $(document).on('click.a11y021', '.color-swatch[role="button"]', function () {
    var $card = $(this).closest('.grid-product');
    var self = this;
    setTimeout(function () {
      $card.find('.color-swatch[role="button"]').attr('aria-pressed', 'false');
      $(self).attr('aria-pressed', 'true');
    }, 0);
  });
  console.log('[A11Y-021] role=button/aria-pressed on', $sw.length, 'swatches');
});

/* SWATCH-NAMES – colour swatch names, group labels and visible tooltip */
jQuery(function ($) {
  // 1 + 2. Names: swatch = colour only, group = "Color options for <real title>"
  function names() {
    $('.grid-product__colors').each(function () {
      var $g = $(this);
      var title = $.trim($g.closest('.grid-product, .grid__item').find('.grid-product__title').first().text());
      if (title && $g.attr('aria-label') !== 'Color options for ' + title) $g.attr({ role: 'group', 'aria-label': 'Color options for ' + title });
      $g.find('.color-swatch').each(function () {
        var c = $(this).attr('data-option-value');
        if (c && $(this).attr('aria-label') !== c) $(this).attr('aria-label', c);
      });
    });
  }
  names();
  new MutationObserver(function () { clearTimeout(window.__a11ySw); window.__a11ySw = setTimeout(names, 200); })
    .observe(document.body, { childList: true, subtree: true });

  // 3. Visible tooltip (WCAG 1.4.13: dismissible, hoverable, persistent)
  var $tip = $('<div id="a11y-swatch-tip" aria-hidden="true"></div>').css({
    position: 'fixed', zIndex: 10000, display: 'none', padding: '4px 8px', borderRadius: '3px',
    background: '#1c1d1d', color: '#fff', fontSize: '13px', lineHeight: '1.3', whiteSpace: 'nowrap'
  }).appendTo('body');
  var cur = null, hideT, dismissed = null, quietUntil = 0;

  function show(el) {
    var c = $(el).attr('data-option-value'); if (!c || el === dismissed || Date.now() < quietUntil) return;
    dismissed = null;
    clearTimeout(hideT); cur = el;
    $tip.text(c).css({ display: 'block', left: 0, top: 0 });
    var r = el.getBoundingClientRect(), w = $tip.outerWidth(), h = $tip.outerHeight();
    var left = Math.max(4, Math.min(r.left + r.width / 2 - w / 2, window.innerWidth - w - 4));
    var top = r.top - h - 6; if (top < 4) top = r.bottom + 6;
    $tip.css({ left: left, top: top });
  }
  function hide(now) {
    clearTimeout(hideT);
    hideT = setTimeout(function () { $tip.hide(); cur = null; }, now ? 0 : 150);
  }

  $(document)
    .on('mouseenter.a11ySwTip focusin.a11ySwTip', '.color-swatch', function () { show(this); })
    .on('mouseleave.a11ySwTip', '.color-swatch', function () { if (this === dismissed) dismissed = null; if (document.activeElement !== this) hide(); })
    .on('focusout.a11ySwTip', '.color-swatch', function () { hide(true); })
    .on('keydown.a11ySwTip', function (e) { if (e.key === 'Escape' && cur) { dismissed = cur; quietUntil = Date.now() + 800; hide(true); } /* 800ms covers the ESC-GUARD focus bounce */ });
  $tip.on('mouseenter', function () { clearTimeout(hideT); }).on('mouseleave', function () { hide(); }); // hoverable
  $(window).on('scroll.a11ySwTip resize.a11ySwTip', function () { if (cur) show(cur); });

  console.log('[A11Y-SWATCH-NAMES] swatch names = colour only, group labels fixed, tooltips added');
});


/* ==========================================================================
   BUG 023 – Hero video pause control
   Fix vs v1: waits for the YT API to replace the placeholder with an <iframe>,
   and pauses through the YT player object (postMessage did not stop playback).
   ========================================================================== */
jQuery(function ($) {
  var $sec = $('[data-section-type="video-section"]');
  if (!$sec.length) return;

  $('<style>.a11y-video-toggle{position:absolute;right:16px;bottom:16px;z-index:5;min-width:44px;min-height:44px;padding:8px 14px;background:#000;color:#fff;border:2px solid #fff;border-radius:4px;font-size:14px;cursor:pointer}.a11y-video-toggle:focus-visible{outline:3px solid #fff;outline-offset:3px}</style>').appendTo('head');

  var tries = 0;
  var wait = setInterval(function () {
    var iframe = $sec.find('iframe')[0];
    if (!iframe && ++tries < 60) return;          // up to ~30s (video is lazy-loaded)
    clearInterval(wait);
    if (!iframe) { console.warn('[A11Y-023] video iframe not found'); return; }

    function player() { return window.YT && YT.get && iframe.id ? YT.get(iframe.id) : null; }
    function cmd(func) {
      var p = player();
      if (p && typeof p[func] === 'function') { p[func](); return; }
      iframe.contentWindow && iframe.contentWindow.postMessage(JSON.stringify({ event: 'command', func: func, args: [] }), '*');
    }

    var $btn = $('<button type="button" class="a11y-video-toggle" aria-pressed="false">Pause background video</button>');
    if ($sec.css('position') === 'static') $sec.css('position', 'relative');
    $sec.append($btn);

    var paused = false;
    function setPaused(p) {
      paused = p; cmd(p ? 'pauseVideo' : 'playVideo');
      $btn.attr('aria-pressed', p ? 'true' : 'false').text(p ? 'Play background video' : 'Pause background video');
    }
    $btn.on('click', function () { setPaused(!paused); });
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) setTimeout(function () { setPaused(true); }, 1500);
    console.log('[A11Y-023] pause/play control added to hero video');
  }, 500);
});


/* ==========================================================================
   BUG 026 – Footer social links open a new tab with no warning
   ========================================================================== */
jQuery(function ($) {
  var n = 0;
  $('footer a[target="_blank"]').each(function () {
    var $a = $(this);
    var label = $a.attr('aria-label') || $.trim($a.text());
    if (/new tab|new window/i.test(label)) return;
    $a.attr('aria-label', label + ' (opens in a new tab)').removeAttr('title');
    n++;
  });
  console.log('[A11Y-026] new-tab warning added to', n, 'footer links');
});


/* ==========================================================================
   BUG 029 (+032, 033, 091) – Generic h1 "Featured Collection"
   Fix vs v1: reads the real collection title from /collections/{handle}.json
   (the <title> split produced "…Holsters| American Bench Craft" and the SEO
   title "Handmade Leather Products for Men" on Accessories).
   ========================================================================== */
jQuery(function ($) {
  if (!$('body').hasClass('template-collection')) return;
  var $h1 = $('main h1').first();
  if (!$h1.length || $.trim($h1.text()).toLowerCase() !== 'featured collection') return;
  var m = location.pathname.match(/\/collections\/([^\/]+)/);
  if (!m) return;
  $.getJSON('/collections/' + m[1] + '.json').done(function (j) {
    if (j && j.collection && j.collection.title) {
      $h1.text(j.collection.title);
      console.log('[A11Y-029] h1 set to "' + j.collection.title + '"');
    }
  });
});


/* ==========================================================================
   BUG 030 (+092) – Filter drawer: no accessible name, focus not trapped
   ========================================================================== */
jQuery(function ($) {
  var $d = $('#FilterDrawer');
  if (!$d.length) return;
  
    $('<style id="a11y-030-focus">' +
    '#FilterDrawer .collapsible-trigger{padding-left:12px!important;padding-right:12px!important}' +
    '#FilterDrawer .collapsible-trigger .collapsible-trigger__icon{right:12px!important}' +
    '#FilterDrawer .collapsible-trigger:focus-visible{outline:3px solid #1c1d1d!important;outline-offset:-3px!important}' +
    '</style>').appendTo('head');

  var $title = $d.find('.drawer__title, h2, h3').filter(function () { return /filter/i.test($(this).text()); }).first();
  if ($title.length) {
    if (!$title.attr('id')) $title.attr('id', 'FilterDrawerTitle');
    $d.attr('aria-labelledby', $title.attr('id'));
  } else {
    $d.attr('aria-label', 'Filter');
  }

  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  $(document).on('keydown.a11y030', '#FilterDrawer', function (e) {
    if (e.key !== 'Tab') return;
    var d = document.getElementById('FilterDrawer');
    var $f = $(d).find(FOCUSABLE).filter(function () { return this.tabIndex >= 0 && this.getClientRects().length && getComputedStyle(this).visibility !== 'hidden' && !this.closest('[inert]'); });
    if (!$f.length) return;
    var first = $f[0], last = $f[$f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === d)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  console.log('[A11Y-030] filter drawer named + focus trap attached');
});


/* ==========================================================================
   BUG 040 – Zoom buttons (tidy-up)
   Fix vs v1: the hidden-slide check matched the button's own aria-hidden.
   ========================================================================== */
// jQuery(function ($) {
//   if (!$('button.product__photo-zoom').length) return;
//   $('<style>.product__photo-zoom:focus-visible{opacity:1!important;visibility:visible!important;outline:3px solid #1c1d1d;outline-offset:2px}</style>').appendTo('head');
//   function sync() {
//     $('button.product__photo-zoom').each(function () {
//       var $b = $(this);
//       $b.find('.icon__fallback-text').text('Zoom product image');
//       $b.attr('aria-label', 'Zoom product image');
//       var slideHidden = $b.parents('[aria-hidden="true"]').length > 0;
//       if (slideHidden) $b.attr({ tabindex: '-1', 'aria-hidden': 'true' });
//       else $b.removeAttr('aria-hidden').attr('tabindex', '0');
//     });
//   }
//   sync();
//   var gal = document.querySelector('[data-product-images]');
//   if (gal) new MutationObserver(function () { clearTimeout(window.__a11y040); window.__a11y040 = setTimeout(sync, 100); })
//     .observe(gal, { attributes: true, subtree: true, attributeFilter: ['aria-hidden', 'class'] });
//   console.log('[A11Y-040] zoom buttons exposed on visible slide only');
// });


/* ==========================================================================
   BUG 042 – Add to Cart: focus not moved into cart drawer
   aria-haspopup="dialog" is already on the button. Focus handling is done by
   the BUG 008 block (it reacts to every drawer open, incl. Add to Cart).
   No separate code needed – enable BUG 008.
   ========================================================================== */


/* ==========================================================================
   BUG 043 – Cart drawer does not close with Escape
   ========================================================================== */
jQuery(function ($) {
  function isOpen() {
    var d = document.querySelector('.upez--inner-drawer-container'); if (!d) return false;
    var r = d.getBoundingClientRect(); return r.width > 0 && r.left < window.innerWidth - 10;
  }
  $(document).on('keydown.a11y043', function (e) {
    if (e.key !== 'Escape' || !isOpen()) return;
    var close = document.querySelector('.upez--close-button');
    if (close) { close.click(); console.log('[A11Y-043] Escape closed cart drawer'); }
  });
});


/* ==========================================================================
   BUG 044 – Quantity buttons named "… quantity, item"
   Fix vs v1: walks up until it finds the product TITLE link (the nearest
   product link is the image link, which has no text).
   ========================================================================== */
jQuery(function ($) {
  function itemName(el) {
    var $p = $(el).parent();
    for (var i = 0; i < 8 && $p.length; i++) {
      var t = $.trim($p.find('a[href*="/products/"]').filter(function () { return $.trim($(this).text()); }).first().text());
      if (t) return t;
      $p = $p.parent();
    }
    return 'item';
  }
  function fix() {
    var root = document.getElementById('upezCartContainer'); if (!root) return;
    $(root).find('.js-qty__adjust').each(function () {
      var $b = $(this);
      var isMinus = $b.parent().find('.js-qty__adjust').index(this) === 0;
      var label = (isMinus ? 'Decrease' : 'Increase') + ' quantity, ' + itemName(this);
      if ($b.attr('aria-label') !== label) $b.attr('aria-label', label);
      if ($b.attr('role') !== 'button') {
        $b.attr({ role: 'button', tabindex: '0' });
        $b.find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' });
      }
    });
  }
  $(document).on('keydown.a11y044', '.js-qty__adjust[role="button"]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
  });
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11y044); window.__a11y044 = setTimeout(fix, 100); })
    .observe(root, { childList: true, subtree: true });
  console.log('[A11Y-044] quantity controls exposed as named buttons');
});


/* ==========================================================================
   BUG 045 – Cart drawer rating stars announced one by one
   Hides the decorative star SVGs; the "NN reviews" text stays readable.
   ========================================================================== */
jQuery(function ($) {
  function fix() {
    var root = document.getElementById('upezCartContainer'); if (!root) return;
    $(root).find('*').filter(function () {
      return this.children.length === 0 && /^\s*\d+\s+reviews?\s*$/i.test(this.textContent);
    }).each(function () {
      var $row = $(this).parent();
      $row.find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' }).removeAttr('role');
    });
  }
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11y045); window.__a11y045 = setTimeout(fix, 150); })
    .observe(root, { childList: true, subtree: true });
  console.log('[A11Y-045] rating star SVGs hidden in cart drawer');
});


/* ==========================================================================
   BUG 046 – Cart drawer prices have no labels
   Labels are inserted BEFORE <upez-money-convert> (not inside) because the
   custom element re-renders its own content.
   ========================================================================== */
jQuery(function ($) {
  function label($el, text) {
    if ($el.prev('.a11y046').length) return;
    $el.before('<span class="visually-hidden a11y046">' + text + ' </span>');
  }
  function fix() {
    $('upez-money-convert.upez--cart-item--discounted-price').each(function () { label($(this), 'Price:'); });
    $('upez-money-convert.upez--subtotal_price').each(function () { label($(this), 'Subtotal:'); });
  }
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11y046); window.__a11y046 = setTimeout(fix, 150); })
    .observe(root, { childList: true, subtree: true });
  console.log('[A11Y-046] price labels active in cart drawer');
});


/* ==========================================================================
   BUG 047 (+106) – Remove (trash) icon not focusable / unnamed
   Fix vs v1: the trash icon is one level higher than v1 searched. It is the
   svg-only <div> in the same row as the quantity stepper (verified live:
   2 icons found for 2 cart lines). Also enlarged to 24x24 (it is 12x15).
   ========================================================================== */
jQuery(function ($) {
  $('<style>[data-a11y047]{display:inline-flex!important;align-items:center;justify-content:center;min-width:24px;min-height:24px;cursor:pointer}[data-a11y047]:focus-visible{outline:3px solid #1c1d1d;outline-offset:2px}</style>').appendTo('head');
  function itemName(el) {
    var $p = $(el).parent();
    for (var i = 0; i < 8 && $p.length; i++) {
      var t = $.trim($p.find('a[href*="/products/"]').filter(function () { return $.trim($(this).text()); }).first().text());
      if (t) return t;
      $p = $p.parent();
    }
    return 'item';
  }
  function fix() {
    var root = document.getElementById('upezCartContainer'); if (!root) return;
    // undo earlier wrong matches (e.g. rating stars tagged as "Remove …" buttons)
    $(root).find('[data-a11y047]').filter(function () { return $(this).children('svg').attr('viewBox') !== '0 0 12 15'; })
      .removeAttr('role tabindex aria-label data-a11y047');
    $(root).find('.js-qty__adjust').each(function () {
      var q = this.getBoundingClientRect(), qMid = q.top + q.height / 2;
      var $scope = $(this).parent().parent().parent();
      $scope.find('div').filter(function () {
        if ($(this).children().length !== 1 || $(this).children('svg').length !== 1) return false;
        if ($(this).children('svg').attr('viewBox') !== '0 0 12 15') return false;   // trash icon only (stars are 0 0 20 19)
        if ($(this).closest('.js-qty__adjust').length || $(this).find('.js-qty__adjust').length) return false;
        var r = this.getBoundingClientRect();
        return Math.abs((r.top + r.height / 2) - qMid) < 30;      // same row as the stepper
      }).not('[data-a11y047]').each(function () {
        $(this).attr({ role: 'button', tabindex: '0', 'aria-label': 'Remove ' + itemName(this), 'data-a11y047': '1' })
          .find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' });
        console.log('[A11Y-047] remove control fixed:', $(this).attr('aria-label'));
      });
    });
  }
  $(document).on('keydown.a11y047', '[data-a11y047]', function (e) {
    if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.click(); }
  });
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11y047); window.__a11y047 = setTimeout(fix, 150); })
    .observe(root, { childList: true, subtree: true });
});


/* STARS-CART – star ratings in the cart drawer */
jQuery(function ($) {
  var FULL = 'M3.825 19L5.45 11.975L0 7.25L7.2 6.625L10 0L12.8 6.625L20 7.25L14.55 11.975L16.175 19L10 15.275L3.825 19Z';
  function fix() {
    var root = document.getElementById('upezCartContainer'); if (!root) return;
    var stars = root.querySelectorAll('svg[viewBox="0 0 20 19"]');
    var groups = [];
    Array.prototype.forEach.call(stars, function (s) {
      var g = s.parentElement;
      while (g && g !== root && g.querySelectorAll('svg[viewBox="0 0 20 19"]').length < 5) g = g.parentElement;
      if (g && g !== root && groups.indexOf(g) < 0) groups.push(g);
    });
    groups.forEach(function (g) {
      var score = 0;
      $(g).find('svg[viewBox="0 0 20 19"]').each(function () {
        var d = ($(this).find('path').attr('d') || '');
        score += d === FULL ? 1 : (d.indexOf('M10 5.125V12.925') === 0 ? 0.5 : 0);
        $(this).attr({ 'aria-hidden': 'true', focusable: 'false' });
      });
      $(g).find('[role="button"], [tabindex], [data-a11y047]').removeAttr('role tabindex aria-label data-a11y047');
      var label = 'Rated ' + score + ' out of 5 stars';
      if (g.getAttribute('aria-label') !== label) $(g).attr({ role: 'img', 'aria-label': label });
    });
  }
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11yStars); window.__a11yStars = setTimeout(fix, 200); })
    .observe(root, { childList: true, subtree: true });
  console.log('[A11Y-STARS-CART] cart star ratings exposed as one image with the rating');
});


/* ==========================================================================
   BUG 048 – Badge image alt is misspelled / incomplete
   ========================================================================== */
jQuery(function ($) {
  var $img = $('img[src*="ProductBadgesLineup"]');
  $img.attr('alt', 'Made in USA, Bench Craft Guarantee, Premium Full Grain Leather');
  console.log('[A11Y-048] badge alt fixed on', $img.length, 'image(s)');
});


/* ==========================================================================
   BUG 049 – Belt Size Guide image has no text equivalent
   Text transcribed from the image; exposed via aria-describedby.
   ========================================================================== */
jQuery(function ($) {
  var $img = $('img[src*="belt_size_guide"], img[alt="Men\'s Belt Sizing Guide"]').first();
  if (!$img.length) return;
  var id = 'a11y-belt-size-guide-desc';
  if (!document.getElementById(id)) {
    $img.after(
      '<div id="' + id + '" class="visually-hidden">' +
      'Belt size guide. Method 1: add 2 to your pant size. Use men\'s pant size values 30, 32, 34, 36, 38, 40 and so on. ' +
      'Example: pant size 34 equals belt size 36. ' +
      'Method 2: measure an existing belt from where the leather folds over the buckle to the hole you wear it on. ' +
      'This measurement is your belt size. Example: a 38 inch measurement equals belt size 38. ' +
      'If in between sizes, round up. Sizing holes are spaced 1 inch apart.</div>');
  }
  $img.attr({ alt: 'Men\'s belt size guide', 'aria-describedby': id });
  console.log('[A11Y-049] belt size guide description added');
});


/* ==========================================================================
   BUG 054 – Dog Collar Size Guide image has no text equivalent
   ========================================================================== */
jQuery(function ($) {
  var $img = $('img').filter(function () { return /dog collar size guide/i.test(this.alt || ''); }).first();
  if (!$img.length) return;
  var id = 'a11y-collar-size-guide-desc';
  if (!document.getElementById(id)) {
    $img.after(
      '<div id="' + id + '" class="visually-hidden">' +
      'Dog collar size guide. Proper sizing: measure the exact circumference snug around your dog\'s neck where you would like the collar to sit. ' +
      'Do not leave breathing room. Example: if your dog\'s neck measures 15 inches, choose a 15 inch dog collar. ' +
      'You will have 5 sizing holes to choose from. Sizing refers to the circumference of your dog\'s neck, not the total length of the collar.</div>');
  }
  $img.attr({ alt: 'Dog collar size guide', 'aria-describedby': id });
  console.log('[A11Y-054] dog collar size guide description added');
});


/* ==========================================================================
   BUG 055 – Junip Write-a-review modal
   Fix vs v1: (a) Escape now closes the modal, (b) focus returns to
   "Write a review" after close (v1 checked too early, while focus was still
   on the hidden close button). Needs ESC-GUARD for (a) to keep focus.
   ========================================================================== */
jQuery(function ($) {
  var opener = null;
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  function modal() { return $('.junip-modal').filter(function () { return this.getClientRects().length > 0; }).first(); }

  $(document).on('click.a11y055', '.junip-write-review-cta', function () { opener = this; });

  $(document).on('keydown.a11y055', '.junip-modal', function (e) {
    var m = this;
    if (e.key === 'Escape') {
      var c = m.querySelector('.junip-close'); if (c) { e.preventDefault(); c.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var $f = $(m).find(FOCUSABLE).filter(':visible');
    if (!$f.length) return;
    var first = $f[0], last = $f[$f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === m)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  var wasOpen = false;
  setInterval(function () {
    var open = modal().length > 0;
    if (!open && wasOpen && opener && document.body.contains(opener)) {
      opener.focus(); console.log('[A11Y-055] focus returned to Write a review');
    }
    wasOpen = open;
  }, 200);
  console.log('[A11Y-055] Junip modal: trap + Escape + focus return');
});


/* ==========================================================================
   BUG 059 – Reviews page testimonial slider: no Previous/Next controls
   Uses the page's Flickity instance (window.Flickity) – VERIFY it exists.
   ========================================================================== */

/* BUG 059 (v2) – Testimonials / review slider */
jQuery(function ($) {
  function setup(el) {
    if (el.__a11y059) return true;
    var flkty = window.Flickity && window.Flickity.data ? window.Flickity.data(el) : null;
    if (!flkty || !$(el).hasClass('flickity-enabled')) return false;   // not started yet
    el.__a11y059 = true;
    var $el = $(el);
    var n = flkty.cells.length;

    // region
    $el.attr({ role: 'region', 'aria-roledescription': 'carousel', 'aria-label': 'Customer reviews' });

    // stars
    $el.find('.testimonial-stars').each(function () {
      if (this.__a11yStars) return; this.__a11yStars = true;
      var count = ($(this).text().match(/★/g) || []).length;
      $(this).attr('aria-hidden', 'true')
        .after('<span class="visually-hidden">Rated ' + count + ' out of 5 stars</span>');
    });

    // slides
    $(flkty.cells.map(function (c) { return c.element; })).each(function (i) {
      $(this).attr({ role: 'group', 'aria-roledescription': 'slide', 'aria-label': 'Review ' + (i + 1) + ' of ' + n });
    });

    // dots: mouse-only, hidden from screen readers
    $el.find('.flickity-page-dots').attr('aria-hidden', 'true');

    // live region + buttons
    var $live = $('<div class="visually-hidden" aria-live="polite" aria-atomic="true"></div>');
    var $nav = $(
      '<div class="a11y-slider-nav" style="display:flex;gap:12px;justify-content:center;margin-top:16px">' +
      '<button type="button" class="btn a11y-prev" aria-label="Previous review">&#8249; Previous</button>' +
      '<button type="button" class="btn a11y-next" aria-label="Next review">Next &#8250;</button></div>');
    $el.after($nav).after($live);
    $nav.find('.a11y-prev').on('click', function () { flkty.previous(true); });
    $nav.find('.a11y-next').on('click', function () { flkty.next(true); });

    flkty.on('change', function (idx) {
      var $s = $(flkty.cells[idx].element);
      var title = $.trim($s.find('strong').first().text());
      var by = $.trim($s.find('cite').first().text());
      var msg = 'Review ' + (idx + 1) + ' of ' + n + (title ? ': ' + title : '') + (by ? ', by ' + by : '');
      $live.text('');
      setTimeout(function () { $live.text(msg); }, 60);
    });
    console.log('[A11Y-059] testimonials slider made accessible');
    return true;
  }

  // wait for the theme to start each slider (it starts lazily when scrolled into view)
  function scan() {
    var pending = 0;
    $('.testimonials-slider').each(function () { if (!setup(this)) pending++; });
    return pending;
  }
  if (scan()) {
    var tries = 0, t = setInterval(function () { if (!scan() || ++tries > 240) clearInterval(t); }, 500);
  }
});

/* ==========================================================================
   BUG 063 – VerifyPass iframe has no title
   (64–67 are inside the cross-origin iframe – see end of file.)
   ========================================================================== */
jQuery(function ($) {
  function fix() {
    $('iframe[src*="verifypass"]').not('[title]').each(function () {
      $(this).attr('title', 'VerifyPass military and first responder discount verification');
      console.log('[A11Y-063] title added to VerifyPass iframe');
    });
  }
  fix();
  new MutationObserver(fix).observe(document.body, { childList: true, subtree: true });
});


/* ==========================================================================
   BUG 073 – Blog share links open a new tab with no warning
   ========================================================================== */
jQuery(function ($) {
  var n = 0;
  $('.social-sharing__link[target="_blank"]').each(function () {
    var $a = $(this);
    var label = $a.attr('aria-label') || $.trim($a.find('.visually-hidden').text());
    if (/new tab/i.test(label)) return;
    $a.attr('aria-label', label + ' (opens in a new tab)');
    $a.find('.visually-hidden').text(label + ' (opens in a new tab)');
    n++;
  });
  console.log('[A11Y-073] new-tab warning added to', n, 'share links');
});


/* ==========================================================================
   BUG 075 – FAQ page has no h1 ("Frequently Asked Questions" is an h2)
   Permanent fix: change the tag in the FAQ section/template.
   ========================================================================== */
jQuery(function ($) {
  var $h2 = $('main h2').filter(function () { return /^\s*frequently asked questions\s*$/i.test($(this).text()); }).first();
  if (!$h2.length || $('main h1').length) return;
  var $h1 = $('<h1></h1>');
  $.each($h2[0].attributes, function () { $h1.attr(this.name, this.value); });
  $h1.html($h2.html());
  $h2.replaceWith($h1);
  console.log('[A11Y-075] FAQ heading promoted to h1');
});


/* ==========================================================================
   BUG 080 – Klaviyo email popup: focus not moved in, not trapped (3rd-party)
   ========================================================================== */
jQuery(function ($) {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var shown = false;
  function getDlg() {
    return $('div[role="dialog"][aria-modal="true"]').filter(function () {
      return /form/i.test(this.getAttribute('aria-label') || '') && this.getBoundingClientRect().height > 0 &&
             $(this).find('form[data-testid^="klaviyo-form"]').length;
    }).first();
  }
  new MutationObserver(function () {
    var $d = getDlg();
    if ($d.length && !shown) {
      shown = true;
      $d.attr('aria-label', 'Sign up for 10% off');
      var $first = $d.find('input[type="email"]').filter(':visible').first();
      if (!$first.length) $first = $d.find(FOCUSABLE).filter(':visible').first();
      setTimeout(function () { $first.focus(); }, 100);
      console.log('[A11Y-080] focus moved into Klaviyo dialog');
    } else if (!$d.length) { shown = false; }
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

  $(document).on('keydown.a11y080', 'div[role="dialog"][aria-modal="true"]', function (e) {
    if (e.key !== 'Tab' || !$(this).find('form[data-testid^="klaviyo-form"]').length) return;
    var d = this, $f = $(d).find(FOCUSABLE).filter(':visible');
    if (!$f.length) return;
    var first = $f[0], last = $f[$f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === d)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
});


/* ==========================================================================
   BUG 082 – Hidden hero slides (aria-hidden="true") keep links in tab order
   ========================================================================== */
jQuery(function ($) {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  function sync() {
    $('.slideshow__slide').each(function () {
      var hidden = this.getAttribute('aria-hidden') === 'true';
      $(this).find(FOCUSABLE).each(function () {
        var $el = $(this);
        if (hidden) {
          if ($el.attr('data-a11y082-ti') === undefined) $el.attr('data-a11y082-ti', $el.attr('tabindex') || '');
          $el.attr('tabindex', '-1');
        } else if ($el.attr('data-a11y082-ti') !== undefined) {
          var old = $el.attr('data-a11y082-ti');
          old ? $el.attr('tabindex', old) : $el.removeAttr('tabindex');
          $el.removeAttr('data-a11y082-ti');
        }
      });
    });
  }
  sync();
  $('.slideshow__slide').each(function () {
    new MutationObserver(sync).observe(this, { attributes: true, attributeFilter: ['aria-hidden'] });
  });
  console.log('[A11Y-082] hidden hero slide links removed from tab order');
});


/* ==========================================================================
   BUG 084 – Off-screen carousel product cards (aria-hidden) still focusable
   ========================================================================== */
jQuery(function ($) {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  function sync() {
    $('.flickity-slider > .grid-product, .flickity-slider > .grid__item').each(function () {
      var hidden = this.getAttribute('aria-hidden') === 'true';
      $(this).find(FOCUSABLE).each(function () {
        var $el = $(this);
        if (hidden) {
          if ($el.attr('data-a11y084-ti') === undefined) $el.attr('data-a11y084-ti', $el.attr('tabindex') || '');
          $el.attr('tabindex', '-1');
        } else if ($el.attr('data-a11y084-ti') !== undefined) {
          var old = $el.attr('data-a11y084-ti');
          old ? $el.attr('tabindex', old) : $el.removeAttr('tabindex');
          $el.removeAttr('data-a11y084-ti');
        }
      });
    });
  }
  sync();
  $('.flickity-slider').each(function () {
    new MutationObserver(function () { clearTimeout(window.__a11y084); window.__a11y084 = setTimeout(sync, 50); })
      .observe(this, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
  });
  console.log('[A11Y-084] hidden carousel cards removed from tab order');
});


/* ==========================================================================
   BUG 095 – Price slider handles are 12x12px (need 24x24)
   Adjust top/right offsets if the handle sits off-centre on the track.
   ========================================================================== */
jQuery(function ($) {
  if (!$('.noUi-handle').length) return;
  $('<style id="a11y-095">' +
    '#FilterDrawer .noUi-horizontal .noUi-handle{width:24px!important;height:24px!important;right:-12px!important;top:50%!important;transform:translateY(-50%);border-radius:50%}' +
    '#FilterDrawer .noUi-handle:focus-visible{outline:3px solid #1c1d1d;outline-offset:2px}' +
    '</style>').appendTo('head');
  console.log('[A11Y-095] slider handles enlarged to 24x24');
});


/* ==========================================================================
   BUG 096 – Price slider keyboard (VERIFY after deploy)
   Fix vs v1: v1 moved the handle correctly but could not apply the filter
   (the theme only filters from noUiSlider's private "change" callback).
   v2 applies the filter by loading the form's query string (same URL the
   theme builds), then reopens the drawer and refocuses the same handle.
   Only trusted (real) key presses are intercepted.
   ========================================================================== */
jQuery(function ($) {
  var timer = null;
  function slider(h) { var t = $(h).closest('.noUi-target')[0]; return t && t.noUiSlider; }
  function commit(h) {
    var form = $(h).closest('form')[0]; if (!form) return;
    var p = new URLSearchParams(new FormData(form));
    var cur = new URLSearchParams(location.search);
    if (cur.get('sort_by')) p.set('sort_by', cur.get('sort_by'));
    sessionStorage.setItem('a11y096Handle', h.getAttribute('data-handle'));
    sessionStorage.setItem('a11y098Pending', '1');   // lets BUG 098 announce the new result count
    console.log('[A11Y-096] applying price filter', p.toString());
    location.search = p.toString();
  }
  document.addEventListener('keydown', function (e) {
    var h = e.target;
    if (!e.isTrusted || !h.classList || !h.classList.contains('noUi-handle') || !h.closest('#FilterDrawer')) return;
    var s = slider(h); if (!s) return;
    if (e.key === 'Enter') { e.preventDefault(); clearTimeout(timer); commit(h); return; }
    var keys = { ArrowLeft: -1, ArrowDown: -1, ArrowRight: 1, ArrowUp: 1, PageDown: -5, PageUp: 5 };
    if (!(e.key in keys)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var step = (s.options && s.options.step) || 1;
    var idx = +h.getAttribute('data-handle');
    var vals = [].concat(s.get()).map(parseFloat);
    var set = [null, null]; set[idx] = vals[idx] + keys[e.key] * step;
    s.set(set);                                   // moves handle + updates hidden inputs via "update"
    var form = $(h).closest('form');              // keep hidden inputs in sync for FormData
    var v = [].concat(s.get()).map(parseFloat);
    form.find('input[name="filter.v.price.gte"]').val(v[0]);
    form.find('input[name="filter.v.price.lte"]').val(v[1]);
    clearTimeout(timer);
    timer = setTimeout(function () { commit(h); }, 1500);
  }, true);

  // after reload: reopen drawer, expand Price, focus the same handle
  var want = sessionStorage.getItem('a11y096Handle');
  if (want !== null) {
    sessionStorage.removeItem('a11y096Handle');
    setTimeout(function () {
      var trig = document.getElementById('FilterDrawerTrigger'); if (!trig) return;
      trig.click();
      setTimeout(function () {
        $('#FilterDrawer button[aria-controls*="price"][aria-expanded="false"]').trigger('click');
        setTimeout(function () {
          var h = document.querySelector('#FilterDrawer .noUi-handle[data-handle="' + want + '"]');
          if (h) { h.focus(); console.log('[A11Y-096] focus restored to price handle'); }
        }, 300);
      }, 500);
    }, 400);
  }
});


/* ==========================================================================
   BUG 097 – Sorting reloads the page and focus is lost to <body>
   Saves the choice before the reload and restores focus to the Sort select
   afterwards (also works if the theme updates via AJAX).
   ========================================================================== */
jQuery(function ($) {
  // capture phase so it runs before the theme's handler navigates away
  document.addEventListener('change', function (e) {
    if (e.target && e.target.id === 'SortBy') {
      sessionStorage.setItem('a11y097Sort', e.target.options[e.target.selectedIndex].text);
    }
  }, true);

  function restore() {
    var txt = sessionStorage.getItem('a11y097Sort');
    var sel = document.getElementById('SortBy');
    if (!txt || !sel) return false;
    if (document.activeElement && document.activeElement !== document.body && document.activeElement !== sel) return false;
    sel.focus();
    sessionStorage.removeItem('a11y097Sort');
    console.log('[A11Y-097] focus restored to Sort control');
    return true;
  }
  if (!restore()) {
    var tries = 0, t = setInterval(function () { if (restore() || ++tries > 20) clearInterval(t); }, 250);
  }
});


/* ==========================================================================
   BUG 098 – No announcement when results change after sort/filter
   ========================================================================== */
jQuery(function ($) {
  if (!$('body').hasClass('template-collection')) return;
  var $live = $('<div class="visually-hidden" role="status" aria-live="polite" id="a11y-098-status"></div>').appendTo('body');

  function count() {
    return $('main .grid-product').filter(function () { return !$(this).closest('.flickity-slider').length; }).length;
  }
  function announce(prefix) {
    var n = count();
    var sortTxt = $('#SortBy option:selected').text();
    setTimeout(function () {
      $live.text((prefix ? prefix + '. ' : '') + n + (n === 1 ? ' product' : ' products') + ' shown' + (sortTxt ? ', sorted by ' + sortTxt : '') + '.');
      console.log('[A11Y-098] announced', $live.text());
    }, 400);
  }

  // after a full reload triggered by sort/filter
  if (sessionStorage.getItem('a11y098Pending')) { sessionStorage.removeItem('a11y098Pending'); announce('Results updated'); }
  $(document).on('change.a11y098', '#SortBy, #FilterDrawer input, #FilterDrawer select', function () {
    sessionStorage.setItem('a11y098Pending', '1');
  });

  // after an AJAX refresh of the grid
  var main = document.querySelector('main');
  var deb;
  new MutationObserver(function (muts) {
    if (!sessionStorage.getItem('a11y098Pending')) return;
    var gridChanged = muts.some(function (m) {
      return [].some.call(m.addedNodes, function (n) { return n.nodeType === 1 && (n.matches('.grid-product') || n.querySelector && n.querySelector('.grid-product')); });
    });
    if (!gridChanged) return;
    clearTimeout(deb);
    deb = setTimeout(function () { sessionStorage.removeItem('a11y098Pending'); announce('Results updated'); }, 500);
  }).observe(main, { childList: true, subtree: true });
});


/* ==========================================================================
   BUG 103 – Focus indicator on unselected variant swatches
   Fix vs v1: the label is inside div.swatch-label-container (not the radio's
   adjacent sibling). Selector verified live.
   ========================================================================== */
jQuery(function ($) {
  if (!$('.variant-input-wrap').length) return;
  $('<style id="a11y-103">' +
    '.variant-input-wrap input[type="radio"]:focus-visible + label,' +
    '.variant-input-wrap input[type="radio"]:focus-visible + .swatch-label-container label' +
    '{outline:3px solid #1c1d1d!important;outline-offset:3px!important}' +
    '</style>').appendTo('head');
  console.log('[A11Y-103] focus style added to variant swatches/buttons');
});


/* ==========================================================================
   BUG 104 – No status message after Add to Cart
   Listens to Shopify /cart/add requests (fetch + jQuery AJAX) and announces.
   ========================================================================== */
jQuery(function ($) {
  var $live = $('<div class="visually-hidden" role="status" aria-live="polite" id="a11y-104-status"></div>').appendTo('body');
  function say(json) {
    var title = (json && (json.product_title || json.title || (json.items && json.items[0] && json.items[0].product_title))) || 'Item';
    $live.text('');
    setTimeout(function () { $live.text(title + ' added to cart.'); console.log('[A11Y-104] announced add to cart:', title); }, 100);
  }
  if (window.fetch && !window.fetch.__a11y104) {
    var orig = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      return orig.apply(this, arguments).then(function (res) {
        if (/\/cart\/add/.test(url) && res.ok) { res.clone().json().then(say).catch(function () { say(null); }); }
        return res;
      });
    };
    window.fetch.__a11y104 = true;
  }
  $(document).ajaxSuccess(function (ev, xhr, opts) {
    if (/\/cart\/add/.test(opts.url || '')) say(xhr.responseJSON);
  });
});


/* ==========================================================================
   BUG 105 – Cart drawer: no dialog semantics / focus not moved
   Covered by BUG 008 (focus in) + BUG 010 (role=dialog + trap). No separate code.
   BUG 106 – Close/quantity/remove not focusable
   Covered by BUG 009 + BUG 044 + BUG 047. No separate code.
   ========================================================================== */


/* ==========================================================================
   BUG 107 – Upsell "Add" buttons all named just "Add"
   ========================================================================== */
jQuery(function ($) {
  function fix() {
    var root = document.getElementById('upezCartContainer'); if (!root) return;
    $(root).find('swiper-slide').each(function () {
      var $s = $(this);
      var title = $.trim($s.find('a[href*="/products/"]').filter(function () { return $.trim($(this).text()); }).first().text());
      if (!title) return;
      $s.find('button').filter(function () { return /^\s*add\s*$/i.test($(this).text()); })
        .attr('aria-label', 'Add ' + title + ' to cart');
    });
  }
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11y107); window.__a11y107 = setTimeout(fix, 150); })
    .observe(root, { childList: true, subtree: true });
  console.log('[A11Y-107] upsell Add buttons named');
});


/* ==========================================================================
   BUG 108 – Off-screen upsell slides stay in the tab order
   ========================================================================== */
jQuery(function ($) {
  var FOCUSABLE = 'a[href], button, input, select, textarea, [tabindex]';
  function sync() {
    var root = document.getElementById('upezCartContainer'); if (!root) return;
    $(root).find('swiper-slide').each(function () {
      var box = (this.closest('swiper-container') || this.parentElement).getBoundingClientRect();
      var r = this.getBoundingClientRect();
      var visible = r.width > 0 && r.left >= box.left - 2 && r.right <= box.right + 2;
      $(this).attr('aria-hidden', visible ? null : 'true');
      $(this).find(FOCUSABLE).each(function () {
        var $el = $(this);
        if (!visible) {
          if ($el.attr('data-a11y108-ti') === undefined) $el.attr('data-a11y108-ti', $el.attr('tabindex') || '');
          $el.attr('tabindex', '-1');
        } else if ($el.attr('data-a11y108-ti') !== undefined) {
          var old = $el.attr('data-a11y108-ti');
          old ? $el.attr('tabindex', old) : $el.removeAttr('tabindex');
          $el.removeAttr('data-a11y108-ti');
        }
      });
    });
  }
  setInterval(sync, 400); // swiper moves via transform; cheap poll is the most reliable
  console.log('[A11Y-108] upsell off-screen slide sync running');
});


/* CART-UPSELL – "YOU MAY ALSO LIKE" slider arrows in the upez cart drawer */
jQuery(function ($) {
  var ARROWS = '#upezCartContainer .upez--swiper-button-prev, #upezCartContainer .upez--swiper-button-next';

  function live() {
    var $l = $('#a11y-upsell-live');
    if (!$l.length) {
      $l = $('<div id="a11y-upsell-live" aria-live="polite" aria-atomic="true"></div>')
        .css({ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' })
        .appendTo(document.getElementById('upezCartContainer') || document.body);
    }
    return $l;
  }

  function announce() {
    var sc = document.querySelector('#upezCartContainer swiper-container'); if (!sc) return;
    var box = sc.getBoundingClientRect(), slides = sc.querySelectorAll('swiper-slide'), shown = [];
    Array.prototype.forEach.call(slides, function (s, i) {
      var r = s.getBoundingClientRect();
      if (r.width && r.left >= box.left - 2 && r.right <= box.right + 2) {
        var t = $.trim($(s).find('a[href*="/products/"]').filter(function () { return $.trim($(this).text()); }).first().text());
        shown.push((i + 1) + ' of ' + slides.length + (t ? ', ' + t : ''));
      }
    });
    if (!shown.length) return;
    var $l = live().text('');
    setTimeout(function () { $l.text('Showing product ' + shown.join('; ')); }, 60);
  }

  function label() {
    var sc = document.querySelector('#upezCartContainer swiper-container'); if (!sc) return;
    var region = sc.parentElement;
    if (region.getAttribute('aria-roledescription') !== 'carousel') {
      region.setAttribute('role', 'region');
      region.setAttribute('aria-roledescription', 'carousel');
      region.setAttribute('aria-label', 'You may also like');
    }
    $(sc).find('swiper-slide').not('[aria-roledescription]').attr('aria-roledescription', 'slide');
    $(ARROWS).find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' });
  }

  // 1. Enter / Space activate the arrows (same as a mouse click)
  $(document).off('keydown.a11yUpsell').on('keydown.a11yUpsell', ARROWS, function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    e.preventDefault();
    if (this.getAttribute('aria-disabled') === 'true') return;
    this.click();
  });

  // 2. Announce what is now visible after any arrow activation
  $(document).off('click.a11yUpsell').on('click.a11yUpsell', ARROWS, function () {
    setTimeout(announce, 450);
  });

  label();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11yUpsell); window.__a11yUpsell = setTimeout(label, 150); })
    .observe(root, { childList: true, subtree: true });
  console.log('[A11Y-CART-UPSELL] upsell arrows keyboard operable + announced');
});

/* CART-FOCUS-VISIBLE – keep focused cart drawer content clear of the sticky
   checkout footer / sticky header (WCAG 2.4.11) */
jQuery(function ($) {
  var GAP = 12;

  function scroller(el) {
    var p = el.parentElement;
    while (p && p.id !== 'upezCartContainer') {
      if (/(auto|scroll)/.test(getComputedStyle(p).overflowY) && p.scrollHeight > p.clientHeight) return p;
      p = p.parentElement;
    }
    return null;
  }

  function limits(sc) {
    var r = sc.getBoundingClientRect(), top = r.top, bottom = r.bottom;
    Array.prototype.forEach.call(sc.querySelectorAll('*'), function (e) {
      var cs = getComputedStyle(e);
      if (cs.position !== 'sticky' || !e.offsetHeight) return;
      var er = e.getBoundingClientRect();
      if (cs.bottom !== 'auto' && er.top > r.top + r.height / 2) bottom = Math.min(bottom, er.top);
      else if (cs.top !== 'auto' && er.bottom < r.top + r.height / 2) top = Math.max(top, er.bottom);
    });
    return { top: top, bottom: bottom };
  }

  document.addEventListener('focusin', function (e) {
    var el = e.target;
    if (!el.closest || !el.closest('#upezCartContainer')) return;
    var sc = scroller(el); if (!sc) return;
    for (var p = el; p && p !== sc; p = p.parentElement) if (getComputedStyle(p).position === 'sticky') return;

    var slider = el.closest('[aria-roledescription="carousel"]') ||
                 (document.querySelector('#upezCartContainer swiper-container') || {}).parentElement;
    var target = slider && slider.contains(el) ? slider : el;

    setTimeout(function () {
      var lim = limits(sc), r = target.getBoundingClientRect();
      if (r.bottom > lim.bottom - GAP) sc.scrollTop += r.bottom - (lim.bottom - GAP);
      r = target.getBoundingClientRect();
      if (r.top < lim.top + GAP) sc.scrollTop -= (lim.top + GAP) - r.top;
      var fr = el.getBoundingClientRect();
      if (fr.bottom > lim.bottom - GAP) sc.scrollTop += fr.bottom - (lim.bottom - GAP);
    }, 0);
  }, true);

  console.log('[A11Y-CART-FOCUS-VISIBLE] cart drawer focus kept clear of sticky header/footer');
});

/* REDO-MODAL – Checkout+ "Checkout with confidence" info popup (Redo app) */
jQuery(function ($) {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var opener = null, isOpen = false;

  function tabbables(d) {
    return Array.prototype.filter.call(d.querySelectorAll(FOCUSABLE), function (el) {
      return el.tabIndex >= 0 && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  function init(host) {
    var sr = host.shadowRoot;
    if (!sr || host.__a11yRedo) return;
    host.__a11yRedo = true;

    function dialog() {
      var d = sr.querySelector('[role="dialog"]');
      return d && d.getClientRects().length ? d : null;
    }

    function check() {
      var d = dialog();
      if (d && !isOpen) {
        isOpen = true;
        var ae = document.activeElement;
        opener = (ae && ae !== host && ae !== document.body) ? ae : opener;
        var h = d.querySelector('[role="heading"]');
        if (h) { h.id = h.id || 'a11y-redo-title'; d.setAttribute('aria-labelledby', h.id); }
        var desc = h && h.nextElementSibling;
        if (desc && !desc.getAttribute('role')) { desc.id = desc.id || 'a11y-redo-desc'; d.setAttribute('aria-describedby', desc.id); }
        $(d).find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' });
        setTimeout(function () { if (dialog()) d.focus(); }, 60);
        console.log('[A11Y-REDO-MODAL] popup opened, focus moved in');
      } else if (!d && isOpen) {
        isOpen = false;
        if (opener && opener.isConnected) setTimeout(function () { opener.focus(); }, 30);
        console.log('[A11Y-REDO-MODAL] popup closed, focus returned');
      }
    }

    new MutationObserver(check).observe(sr, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    sr.addEventListener('keydown', function (e) {
      var d = dialog(); if (!d) return;
      if (e.key === 'Escape') {
        e.stopPropagation();                 // don't let BUG 043 close the cart drawer
        e.preventDefault();
        var x = d.querySelector('[data-target="redo-modal-close-button"], button[aria-label="Close"]');
        if (x) x.click();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = tabbables(d); if (!f.length) return;
      var cur = sr.activeElement, first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (cur === first || cur === d || f.indexOf(cur) < 0)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (cur === last || f.indexOf(cur) < 0)) { e.preventDefault(); first.focus(); }
    }, true);

    check();
  }

  var tries = 0;
  (function wait() {
    var host = document.getElementById('redo-modal-root');
    if (host && host.shadowRoot) init(host);
    else if (tries++ < 120) setTimeout(wait, 500);
  })();
  console.log('[A11Y-REDO-MODAL] Checkout+ info popup focus management running');
});

/* REDO-MODAL – Checkout+ "Checkout with confidence" info popup (Redo app) */
jQuery(function ($) {
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])';
  var opener = null, isOpen = false;

  function tabbables(d) {
    return Array.prototype.filter.call(d.querySelectorAll(FOCUSABLE), function (el) {
      return el.tabIndex >= 0 && el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden';
    });
  }

  function init(host) {
    var sr = host.shadowRoot;
    if (!sr || host.__a11yRedo) return;
    host.__a11yRedo = true;

    function dialog() {
      var d = sr.querySelector('[role="dialog"]');
      return d && d.getClientRects().length ? d : null;
    }

    function check() {
      var d = dialog();
      if (d && !isOpen) {
        isOpen = true;
        var ae = document.activeElement;
        opener = (ae && ae !== host && ae !== document.body) ? ae : opener;
        var h = d.querySelector('[role="heading"]');
        if (h) { h.id = h.id || 'a11y-redo-title'; d.setAttribute('aria-labelledby', h.id); }
        var desc = h && h.nextElementSibling;
        if (desc && !desc.getAttribute('role')) { desc.id = desc.id || 'a11y-redo-desc'; d.setAttribute('aria-describedby', desc.id); }
        $(d).find('svg').attr({ 'aria-hidden': 'true', focusable: 'false' });
        setTimeout(function () { if (dialog()) d.focus(); }, 60);
        console.log('[A11Y-REDO-MODAL] popup opened, focus moved in');
      } else if (!d && isOpen) {
        isOpen = false;
        if (opener && opener.isConnected) setTimeout(function () { opener.focus(); }, 30);
        console.log('[A11Y-REDO-MODAL] popup closed, focus returned');
      }
    }

    new MutationObserver(check).observe(sr, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class'] });

    sr.addEventListener('keydown', function (e) {
      var d = dialog(); if (!d) return;
      if (e.key === 'Escape') {
        e.stopPropagation();                 // don't let BUG 043 close the cart drawer
        e.preventDefault();
        var x = d.querySelector('[data-target="redo-modal-close-button"], button[aria-label="Close"]');
        if (x) x.click();
        return;
      }
      if (e.key !== 'Tab') return;
      var f = tabbables(d); if (!f.length) return;
      var cur = sr.activeElement, first = f[0], last = f[f.length - 1];
      if (e.shiftKey && (cur === first || cur === d || f.indexOf(cur) < 0)) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (cur === last || f.indexOf(cur) < 0)) { e.preventDefault(); first.focus(); }
    }, true);

    check();
  }

  var tries = 0;
  (function wait() {
    var host = document.getElementById('redo-modal-root');
    if (host && host.shadowRoot) init(host);
    else if (tries++ < 120) setTimeout(wait, 500);
  })();
  console.log('[A11Y-REDO-MODAL] Checkout+ info popup focus management running');
});


/* ==========================================================================
   BUG 110 – Upsell "NN reviews" text contrast ~3.9:1
   #595959 on white = 7:1.
   ========================================================================== */
jQuery(function ($) {
  function fix() {
    var root = document.getElementById('upezCartContainer'); if (!root) return;
    $(root).find('*').filter(function () {
      return this.children.length === 0 && /^\s*\d+\s+reviews?\s*$/i.test(this.textContent);
    }).css('color', '#595959');
  }
  fix();
  var root = document.getElementById('upezCartContainer');
  if (root) new MutationObserver(function () { clearTimeout(window.__a11y110); window.__a11y110 = setTimeout(fix, 150); })
    .observe(root, { childList: true, subtree: true });
  console.log('[A11Y-110] upsell review-count colour darkened');
});


/* ==========================================================================
   BUG 114 – Predictive search combobox
   Fix vs v1: #predictive-search-results does not exist until the first
   search, so v1 exited at DOM ready. v2 uses delegated events and observes
   the search container that exists on load.
   ========================================================================== */
jQuery(function ($) {
  var host = document.querySelector('.site-header__search');
  if (!host) return;
  var idx = -1;
  $('<style>#predictive-search-results .a11y-active{outline:3px solid #1c1d1d;outline-offset:-3px;background:#f2f2f2}</style>').appendTo('head');

  function input() { return document.getElementById('Search'); }
  function res() { return document.getElementById('predictive-search-results'); }
  function items() { var r = res(); return r ? $(r).find('a[href]').filter(':visible') : $(); }
  function isOpen() { var r = res(); return !!(r && r.getBoundingClientRect().height > 0 && items().length); }
  function sync() {
    var i = input(); if (!i) return;
    var r = res(); if (r && r.getAttribute('role') !== 'listbox') r.setAttribute('role', 'listbox');
    var open = isOpen();
    if (i.getAttribute('aria-expanded') !== String(open)) i.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open) { idx = -1; i.removeAttribute('aria-activedescendant'); }
  }
  function activate(n) {
    var $it = items(); if (!$it.length) return;
    idx = (n + $it.length) % $it.length;
    $it.removeClass('a11y-active').attr('aria-selected', 'false');
    var $el = $it.eq(idx);
    if (!$el.attr('id')) $el.attr('id', 'a11y-ps-opt-' + idx);
    if (!$el.attr('role')) $el.attr('role', 'option');
    $el.addClass('a11y-active').attr('aria-selected', 'true');
    input().setAttribute('aria-activedescendant', $el.attr('id'));
    $el[0].scrollIntoView({ block: 'nearest' });
  }
  $(document).on('keydown.a11y114', '#Search', function (e) {
    sync();
    if (!isOpen()) return;
    if (e.key === 'ArrowDown') { e.preventDefault(); activate(idx + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); activate(idx - 1); }
    else if (e.key === 'Enter' && idx > -1) { e.preventDefault(); window.location.href = items().eq(idx).attr('href'); }
  });
  $(document).on('input.a11y114 focus.a11y114', '#Search', function () { idx = -1; setTimeout(sync, 50); });
  new MutationObserver(function () { clearTimeout(window.__a11y114); window.__a11y114 = setTimeout(sync, 60); })
    .observe(host, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  console.log('[A11Y-114] combobox expanded state + arrow keys (delegated) attached');
});


/* ==========================================================================
   BUG 115 – Announce number of predictive search results
   Fix vs v1: same late-render problem as 114 – now observes the search
   container that exists on load and creates the live region up front.
   ========================================================================== */
jQuery(function ($) {
  var host = document.querySelector('.site-header__search');
  if (!host) return;
  var $live = $('<div class="visually-hidden" role="status" aria-live="polite" id="a11y-115-status"></div>').appendTo(host);
  var t, lastMsg = '';
  new MutationObserver(function (muts) {
    if (muts.every(function (m) { return $live[0].contains(m.target); })) return; // ignore own updates
    clearTimeout(t);
    t = setTimeout(function () {
      var i = document.getElementById('Search');
      var r = document.getElementById('predictive-search-results');
      if (!i || !$.trim(i.value)) { $live.text(''); lastMsg = ''; return; }
      var n = r && r.getBoundingClientRect().height > 0 ? $(r).find('a[href]').filter(':visible').length : 0;
      var msg = n ? n + ' suggestions available. Use up and down arrows to review.' : 'No results found.';
      if (msg !== lastMsg) { $live.text(msg); lastMsg = msg; console.log('[A11Y-115] announced', msg); }
    }, 600);
  }).observe(host, { childList: true, subtree: true });
});
/* ==========================================================================
   BUG 120 – Mobile nav drawer: no accessible name, focus not trapped
   ========================================================================== */
jQuery(function ($) {
  var $d = $('#NavDrawer');
  if (!$d.length) return;
  $d.attr('aria-label', 'Site navigation');
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])';
  $d.on('keydown.a11y120', function (e) {
    if (e.key !== 'Tab') return;
    var $f = $d.find(FOCUSABLE).filter(':visible');
    if (!$f.length) return;
    var first = $f[0], last = $f[$f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === $d[0])) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
  console.log('[A11Y-120] nav drawer named + focus trap attached');
});


/* ==========================================================================
   BUG 121 – Junip logo link (44x18) and upsell title links (187x15) < 24px
   ========================================================================== */
jQuery(function ($) {
  $('<style id="a11y-121">' +
    '[class*="junip"] a[href*="junip"]{display:inline-flex!important;align-items:center;min-height:24px;min-width:24px}' +
    '#upezCartContainer swiper-slide a[href*="/products/"]{display:inline-flex!important;align-items:center;min-height:24px}' +
    '</style>').appendTo('head');
  console.log('[A11Y-121] minimum 24px target size applied');
});


/* ==========================================================================
   NOT FIXABLE WITH jQUERY (needs content / vendor / manual work)
   --------------------------------------------------------------------------
   BUG 023 (part) – Captions, transcript and audio description for the hero
                    video: needs real content. Pause control is in the BUG 023 block.
   BUG 064–067    – Headings, duplicate "GET CODE" names and new-tab warnings are
                    inside the cross-origin VerifyPass iframe. The parent page
                    cannot change them; raise with VerifyPass or use their
                    link-based (non-iframe) integration.
   BUG 070        – Blog YouTube videos need a transcript/audio description
                    written by the client. Suggested markup under each video:
                    <details><summary>Video transcript: {title}</summary>…</details>
   BUG 118        – Contact form error handling: verify with a test submission.
   ========================================================================== */


/* NAV-HOVER – restore hover open, stop chevron flash, keep a11y menu intact */
jQuery(function ($) {
  var tries = 0;
  (function init() {
    var $nav = $('.site-nav.site-navigation');
    if (!$nav.length) return;
    if (!$nav.hasClass('js-click-nav')) { if (tries++ < 40) setTimeout(init, 50); return; }
    if ($nav.data('a11yHoverNav')) return;
    $nav.data('a11yHoverNav', true);

    // 1. Remove the a11y.js rules that force the dropdown hidden while hovered
    var st = document.getElementById('js-click-nav-styles');
    if (st && st.sheet) {
      for (var i = st.sheet.cssRules.length - 1; i >= 0; i--) {
        if (/:hover/.test(st.sheet.cssRules[i].selectorText || '')) st.sheet.deleteRule(i);
      }
    }

        // 1b. Remove the white "tab" background on the open parent link (keep header colours)
    var navColor = getComputedStyle($nav.find('.site-nav__link').get(0)).color;
    $('<style id="a11y-nav-no-white">' +
      '.site-nav.site-navigation .site-nav--has-dropdown.is-focused > a.site-nav__link,' +
      '.site-nav.site-navigation .site-nav--has-dropdown:hover > a.site-nav__link{background-color:transparent!important;color:' + navColor + '!important}' +
      '.site-nav.site-navigation .site-nav--has-dropdown.is-focused > a.site-nav__link::before,' +
      '.site-nav.site-navigation .site-nav--has-dropdown:hover > a.site-nav__link::before{display:none!important}' +
      '</style>').appendTo('head');

    var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');

    $nav.find('.site-nav__item.site-nav--has-dropdown').each(function () {
      var li = this, $li = $(li);
      var $btn = $li.children('.site-nav__chevron-btn').first();
      if (!$btn.length) return;
      var mode = null, closeTimer;   // 'hover' | 'click' | 'dismissed' | null

      function toggle() { $btn.triggerHandler('click'); }   // uses a11y.js's own handler
      function isOpen() { return $li.hasClass('is-open'); }

      // 2. Mouse hover opens / closes (like live)
      $li.on('mouseenter.a11yHoverNav', function () {
        if (!fineHover.matches) return;
        clearTimeout(closeTimer);
        if (!isOpen() && mode !== 'dismissed') { toggle(); mode = 'hover'; }
      });
      $li.on('mouseleave.a11yHoverNav', function () {
        if (!fineHover.matches) return;
        if (mode === 'dismissed') { mode = null; return; }
        if (mode !== 'hover') return;
        closeTimer = setTimeout(function () {
          if (mode === 'hover' && isOpen()) toggle();
          mode = null;
        }, 150);
      });

      // 3. Mouse click on chevron while hover-opened = keep open (no flash)
      li.addEventListener('click', function (e) {
        if (!$btn[0].contains(e.target)) return;
        if (e.detail > 0 && isOpen() && mode === 'hover') {
          e.stopPropagation(); e.preventDefault(); mode = 'click';
        }
      }, true);
      li.addEventListener('click', function (e) {
        if (!$btn[0].contains(e.target)) return;
        mode = isOpen() ? 'click' : (mode === 'click' ? null : mode);
      }, false);

      // 4. WCAG 1.4.13 – Escape dismisses hover content without moving the mouse
      $(document).on('keydown.a11yHoverNav', function (e) {
        if ((e.key === 'Escape' || e.keyCode === 27) && isOpen() && mode === 'hover') {
          toggle(); mode = 'dismissed';
        }
      });
    });
    console.log('[A11Y-NAV-HOVER] hover open restored, chevron kept accessible');
  })();
});


/* COLLECTION-TABS – homepage collection switcher out of sync after arrow keys */
jQuery(function () {
  document.addEventListener('keydown', function (e) {
    var tab = e.target.closest && e.target.closest('.collection-switcher__trigger[role="tab"]');
    if (!tab) return;
    var k = e.key;
    if (['ArrowRight', 'ArrowLeft', 'Home', 'End'].indexOf(k) < 0) return;
    var list = tab.closest('[role="tablist"]'); if (!list) return;
    var tabs = Array.prototype.slice.call(list.querySelectorAll('.collection-switcher__trigger[role="tab"]'));
    var i = tabs.indexOf(tab), n = tabs.length;
    var j = k === 'ArrowRight' ? (i + 1) % n : k === 'ArrowLeft' ? (i - 1 + n) % n : k === 'Home' ? 0 : n - 1;
    e.preventDefault();
    e.stopPropagation();          // skip a11y.js's jQuery keydown (it only half-switches)
    tabs[j].focus();
    tabs[j].click();              // real click: theme switches the panel + a11y.js syncs aria-selected
  }, true);
  console.log('[A11Y-COLLECTION-TABS] collection switcher arrow keys switch visually + aria');
});

/* SKRIM-ALT – collection tiles announce image alt + title */
jQuery(function ($) {
  function fix() {
    $('a.skrim__link').each(function () {
      var $a = $(this);
      if (!$.trim($a.find('.skrim__title').text())) return;   // keep alt if a tile has no visible title
      $a.find('img').each(function () { if (this.getAttribute('alt') !== '') this.setAttribute('alt', ''); });
    });
  }
  fix();
  new MutationObserver(function () { clearTimeout(window.__a11ySkrim); window.__a11ySkrim = setTimeout(fix, 200); })
    .observe(document.body, { childList: true, subtree: true });
  console.log('[A11Y-SKRIM-ALT] collection tile images marked decorative');
});


/* ==========================================================================
   NEWSLETTER-FOOTER – Footer "Sign up" email field
   Place: ada-pro.js, at the very END of the file.
   Issues:
   1. No visible label – only a placeholder that disappears while typing
      (WCAG 3.3.2 / 2.5.3). A second <label> points at the submit button.
   2. Submit button name is a long instruction sentence instead of "Subscribe".
   3. Empty / invalid email: only the browser's native bubble (or nothing),
      no persistent, descriptive, programmatically linked error (WCAG 3.3.1, 3.3.3).
   4. After the page reloads, the server success/error message is not
      announced and focus lands at the top of the page (WCAG 4.1.3, 2.4.3).
   Fix: visible "Email" label, required field, inline error text linked with
   aria-describedby + aria-invalid, role=alert announcement, focus moved to
   the field on error and to the message on success.
   ========================================================================== */
jQuery(function ($) {
  var $form = $('#newsletter-footer');
  var $input = $('#Email-footer-2');
  if (!$form.length || !$input.length) return;
  var $btn = $form.find('button[type="submit"]');

  // ---------- styles ----------
  $('<style id="a11y-newsletter-css">' +
    '#newsletter-footer .a11y-nl-label{display:block;margin:0 0 8px;font-size:14px;font-weight:600;color:#fff;letter-spacing:.02em}' +
    '#newsletter-footer .a11y-nl-error{display:none;margin:8px 0 0;font-size:14px;line-height:1.4;color:#ff9b8f}' +
    '#newsletter-footer .a11y-nl-error.is-visible{display:block}' +
    '#newsletter-footer input[aria-invalid="true"]{border:2px solid #ff9b8f!important}' +
    '.a11y-nl-success{margin:8px 0 0;font-size:14px;color:#000}' +
    '.a11y-nl-success:focus{outline:2px solid #fff;outline-offset:3px}' +
    '</style>').appendTo('head');

  // ---------- 1 + 2. label, required, button name ----------
  $form.find('label[for="' + $btn.attr('id') + '"]').remove();                 // label on a button is invalid
  var $label = $form.find('label[for="Email-footer-2"]');
  $label.removeClass('hidden-label visually-hidden').addClass('a11y-nl-label').text('Email');
  $input.closest('.footer__newsletter').before($label);                         // visible above the field
  $input.attr({ required: 'required', 'aria-required': 'true', inputmode: 'email' });
  $btn.attr('aria-label', 'Subscribe');
  $form.attr('novalidate', 'novalidate');                                       // we show our own, readable errors

  // ---------- 3. inline error ----------
  var $err = $('<p id="Email-footer-2-error" class="a11y-nl-error" role="alert"></p>');
  $input.closest('.footer__newsletter').after($err);

  function showError(msg) {
    $err.text('').addClass('is-visible');
    setTimeout(function () { $err.text('Error: ' + msg); }, 50);              // re-announce even if same text
    $input.attr({ 'aria-invalid': 'true', 'aria-describedby': 'Email-footer-2-error' });
    $input.trigger('focus');
  }
  function clearError() {
    $err.removeClass('is-visible').text('');
    $input.removeAttr('aria-invalid aria-describedby');
  }

  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  // capture phase on window: runs BEFORE Shopify's own form handler, which otherwise
  // re-submits the form with form.submit() and ignores preventDefault()
  window.addEventListener('submit', function (e) {
    if (e.target !== $form[0]) return;
    var v = $.trim($input.val()), msg = '';
    if (!v) msg = 'Enter your email address.';
    else if (!EMAIL.test(v)) msg = 'Enter a valid email address, for example name@example.com.';
    if (msg) { e.preventDefault(); e.stopImmediatePropagation(); showError(msg); return; }
    clearError();
  }, true);
  $input.on('input.a11yNl', function () { if ($input.attr('aria-invalid') && EMAIL.test($.trim($input.val()))) clearError(); });

  // ---------- 4. after the page reloads with the server result ----------
  // Shopify returns to  ?customer_posted=true#newsletter-footer  on success and to
  // ?form_type=customer&contact[context]=footer…#newsletter-footer  on failure.
  // The theme prints NO message in either case, so we add one.
  var q = location.search;
  var cameBack = location.hash === '#newsletter-footer' || /contact%5Bcontext%5D=footer|contact\[context\]=footer/.test(q);
  if (cameBack) {
    var $scope = $form.add($form.parent());
    var $themeOk = $scope.find('#newsletter-footer-success, .note--success, .form-success').first();
    var $themeErr = $scope.find('.errors, .note--error, .form-error').first();
    var ok = /customer_posted=true/.test(q) || $themeOk.length;

    if (ok) {
      var $ok = $themeOk.length ? $themeOk : $('<p id="newsletter-footer-success"></p>')
        .text('Thanks for subscribing! You are now on our email list.').insertAfter($form);
      $ok.addClass('a11y-nl-success').attr({ role: 'status', tabindex: '-1' });
      setTimeout(function () { $ok[0].scrollIntoView({ block: 'center' }); $ok.trigger('focus'); }, 300);
    } else {
      var txt = $.trim($themeErr.text()).replace(/\s+/g, ' ');
      if (!txt || /invalid/i.test(txt)) txt = 'We couldn\u2019t sign you up. Check that your email address is correct, for example name@example.com, and try again.';
      else if (/blank/i.test(txt)) txt = 'Enter your email address.';
      else if (/taken|already/i.test(txt)) txt = 'This email address is already subscribed.';
      $themeErr.attr('aria-hidden', 'true').hide();
      setTimeout(function () { $input[0].scrollIntoView({ block: 'center' }); showError(txt); }, 300);
    }
  }
  console.log('[A11Y-NEWSLETTER] footer signup: label, errors, announcements, focus');
});

/* VARIANT-ENTER – Enter on product options adds to cart instead of selecting */
jQuery(function ($) {
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var el = e.target;
    if (!el || el.tagName !== 'INPUT') return;
    var form = el.form;
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    if (/^(submit|button|image|reset)$/i.test(el.type)) return;      // real buttons keep working
    e.preventDefault();                                              // stop the form submitting
    if (el.type === 'radio' || el.type === 'checkbox') {
      if (el.type === 'checkbox' || !el.checked) el.click();         // select it, fires the theme's change
    }
  }, true);
  console.log('[A11Y-VARIANT-ENTER] Enter on product options selects instead of adding to cart');
});




/* NAVDRAWER-FOCUS – mobile menu drawer: focus outline clipped / misplaced */
jQuery(function ($) {
  $('<style id="a11y-navdrawer-focus">' +
    '#NavDrawer a:focus-visible,#NavDrawer button:focus-visible{outline:3px solid #1c1d1d!important;outline-offset:-3px!important;box-shadow:none!important}' +
    '#NavDrawer .mobile-nav__child-item{align-items:center}' +
    '#NavDrawer .mobile-nav__child-item>.collapsible-trigger{width:44px;height:44px;padding:0!important;margin-left:4px;flex:0 0 44px;display:flex;align-items:center;justify-content:center;border-radius:50%}' +
    '#NavDrawer .mobile-nav__child-item>.collapsible-trigger .collapsible-trigger__icon{position:relative!important;top:auto!important;left:auto!important;right:auto!important;transform:none!important}' +
    '</style>').appendTo('head');
  console.log('[A11Y-NAVDRAWER-FOCUS] mobile menu focus rings visible');
});

/* NAVDRAWER-COLLAPSED – links inside collapsed mobile sub-menus still exposed */
jQuery(function () {
  var d = document.getElementById('NavDrawer');
  if (!d) return;
  function sync() {
    d.querySelectorAll('button.collapsible-trigger[aria-controls]').forEach(function (b) {
      var p = document.getElementById(b.getAttribute('aria-controls'));
      if (!p) return;
      var closed = b.getAttribute('aria-expanded') !== 'true';
      if (p.inert !== closed) p.inert = closed;
    });
  }
  sync();
  new MutationObserver(sync).observe(d, { subtree: true, childList: true, attributes: true, attributeFilter: ['aria-expanded'] });
  console.log('[A11Y-NAVDRAWER-COLLAPSED] collapsed mobile sub-menus made inert');
});

/* ==========================================================================
   PDP-THUMBS (v2) – Product page image thumbnails
   Place: ada-pro.js – REPLACES the previous PDP-THUMBS block (end of file).
   v2: the theme only shows the thumbnails of the selected colour/buckle (5 of
   13 for Legacy Belt), so "image 2 of 13" was wrong. Numbering and totals are
   now taken from the thumbnails that are actually visible, in visual order,
   and recalculated whenever the variant changes. Image names are matched by
   image file, not by index.
   ========================================================================== */
jQuery(function ($) {
  var $thumbs = $('.product__thumb[data-index]');
  var $slides = $('.product-main-slide');
  if (!$thumbs.length || !$slides.length) return;

  var $live = $('#a11y-pdp-img-status');
  if (!$live.length) $live = $('<div id="a11y-pdp-img-status" class="visually-hidden" aria-live="polite" aria-atomic="true"></div>')
    .css({ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' })
    .appendTo('body');

  function file(el) {
    var img = $(el).find('img').get(0); if (!img) return '';
    var s = img.getAttribute('data-src') || img.currentSrc || img.getAttribute('src') || '';
    return s.split('?')[0].split('/').pop().replace(/_\{width\}x|_\d+x\d*(?=\.)/g, '');
  }

  // function altFor(el) {                                   // alt of the main slide showing the same file
  //   var f = file(el), alt = '';
  //   $slides.each(function () { if (file(this) === f) { alt = $.trim($(this).find('img').attr('alt') || ''); return false; } });
  //   return alt.replace(/\s+/g, ' ');
  // }

  function slideAlt(el) {                                  // alt of the main slide showing the same file
        var f = file(el), alt = '';
        $slides.each(function () { if (file(this) === f) { alt = $.trim($(this).find('img').attr('alt') || ''); return false; } });
        return alt.replace(/\s+/g, ' ');
      }

      var LEATHER  = { BR: 'brown', BL: 'black', TAN: 'tan', NAT: 'natural' },
          HARDWARE = { BR: 'brass', NI: 'nickel', BK: 'black' },
          productTitle = $.trim($('.product-single__title, h1').first().text()),
          productJson  = null;
      try {
        var pj = $('script[id^="ProductJson-"], script[data-product-json]').first().html();
        productJson = pj ? JSON.parse(pj) : null;
      } catch (e) {}

      function fromCode(alt) {                                 // "...ABC-MTC-GER-BR-BR" -> "brown leather with brass hardware"
        var m = alt.match(/-(BR|BL|TAN|NAT)-(BR|NI|BK)\s*$/i);
        if (!m) return '';
        var leather = LEATHER[m[1].toUpperCase()], hw = HARDWARE[m[2].toUpperCase()];
        return leather ? leather + ' leather' + (hw ? ' with ' + hw + ' hardware' : '') : '';
      }

      function fromVariants(el) {                              // fallback: colour option of the variants this thumb belongs to
        if (!productJson || !productJson.variants) return '';
        var ids = $.grep(($(el).closest('.product__thumb-item').data('variants') + '').split(','), function (x) { return x; }),
            colours = {};
        $.each(productJson.variants, function (_, v) {
          if ($.inArray(String(v.id), ids) > -1 && v.option1) colours[v.option1] = 1;
        });
        var names = $.map(colours, function (_, k) { return k.toLowerCase(); });
        return names.length === 1 ? names[0] + ' leather' : '';
      }

function altFor(el) {
  var alt = slideAlt(el),
      looksLikeCode = /--|\bABC-|-[A-Z]{2,3}-[A-Z]{2}$/.test(alt),
      detail = fromCode(alt) || fromVariants(el);
  if (alt && !looksLikeCode) return alt;                 // real alt written in admin wins
  return detail ? productTitle + ', ' + detail : productTitle;
}

  function visibleThumbs() {
    return $thumbs.filter(function () { return this.getClientRects().length; }).get()
      .sort(function (a, b) { var ra = a.getBoundingClientRect(), rb = b.getBoundingClientRect(); return (ra.top - rb.top) || (ra.left - rb.left); });
  }

  var lastKey = null, ready = false;
  function sync() {
    var vis = visibleThumbs(), m = vis.length;
    vis.forEach(function (t, k) {
      var alt = altFor(t);
      t.setAttribute('aria-label', 'View image ' + (k + 1) + ' of ' + m + (alt ? ': ' + alt : ''));
      $(t).find('img').attr('alt', '');
    });
    // selected = thumbnail showing the same file as the selected main slide
    var sel = $slides.filter('.is-selected').get(0), f = sel ? file(sel) : '';
    var active = vis.filter(function (t) { return file(t) === f; })[0] || $thumbs.filter('.is-active').get(0);
    $thumbs.removeAttr('aria-current');
    if (active) active.setAttribute('aria-current', 'true');
    var k = vis.indexOf(active), key = f + '|' + m;
    if (key !== lastKey) {
      if (ready && sel) {
        var alt = altFor(sel);
        var msg = 'Showing image' + (k >= 0 ? ' ' + (k + 1) + ' of ' + m : '') + (alt ? ': ' + alt : '');
        $live.text('');
        setTimeout(function () { $live.text(msg); }, 80);
      }
      lastKey = key;
    }
     $slides.each(function () {
        var $img = $(this).find('img');
        if (/--|\bABC-|-[A-Z]{2,3}-[A-Z]{2}$/.test($img.attr('alt') || '')) $img.attr('alt', altFor(this));
      });

}
  sync();
  setTimeout(function () { ready = true; }, 1500);         // no announcement on page load

  var mo = new MutationObserver(function () { clearTimeout(window.__a11yThumbs); window.__a11yThumbs = setTimeout(sync, 150); });
  $slides.add($thumbs).add($thumbs.parent()).each(function () { mo.observe(this, { attributes: true, attributeFilter: ['class', 'style'] }); });

  console.log('[A11Y-PDP-THUMBS] v2 thumbnails numbered by visible images, change announced');
});


/* DROPDOWN-FOCUS – desktop mega-menu links: bottom edge of focus outline missing */
jQuery(function ($) {
  $('<style id="a11y-dropdown-focus">' +
    '.site-nav__dropdown a:focus-visible,.site-nav__dropdown button:focus-visible{outline:3px solid #1c1d1d!important;outline-offset:-3px!important;z-index:8!important;box-shadow:none!important}' +
    '</style>').appendTo('head');
  console.log('[A11Y-DROPDOWN-FOCUS] desktop dropdown focus outline complete');
});


/* ==========================================================================
   FILTER-APPLY – Collection filters apply instantly on checkbox change
   Place: ada-pro.js, at the very END of the file.
   Root cause: the theme listens for "input" on .filter-form and re-renders the
   product grid the moment a checkbox changes (theme.Collection.onFormSubmit).
   That is an unexpected change of context for keyboard / screen reader users
   (WCAG 3.2.2 On Input), and nothing announces that the results changed
   (WCAG 4.1.3).
   Fix: checkbox changes are held back (status message instead), an
   "Apply filters" button at the end of the filter list applies them, and the
   result is announced: "Filters applied. 16 products." If the panel stays open
   (desktop sidebar) focus goes back to Apply filters; in the drawer the theme
   closes it and returns focus to the "Filter (n)" button.
   ========================================================================== */
jQuery(function ($) {
  var SEL = '.filter-form input[type="checkbox"], .filter-form input[type="radio"]';
  var pass = false, pending = null, refocus = false;

  var $live = $('<div id="a11y-filter-status" class="visually-hidden" aria-live="polite" aria-atomic="true"></div>')
    .css({ position: 'absolute', width: '1px', height: '1px', overflow: 'hidden', clip: 'rect(0 0 0 0)', whiteSpace: 'nowrap' })
    .appendTo('body');
  function say(msg) { $live.text(''); setTimeout(function () { $live.text(msg); }, 80); }

  $('<style id="a11y-filter-apply-css">.a11y-filter-apply{margin:20px 0 10px}.a11y-filter-apply .btn{width:100%}.a11y-filter-apply .btn:focus-visible{outline:3px solid #1c1d1d;outline-offset:3px}</style>').appendTo('head');

  function ensureButtons() {
    $('.filter-form').each(function () {
      if ($(this).find('.a11y-filter-apply').length) return;
      $('<div class="a11y-filter-apply"><button type="button" class="btn">Apply filters</button></div>').appendTo(this);
    });
  }
  ensureButtons();

  function labelOf(el) {
    var l = el.labels && el.labels[0];
    return $.trim((l ? $(l).text() : el.value) || '').replace(/\s+/g, ' ');
  }

  // 1. hold back the theme's instant filtering
  window.addEventListener('input', function (e) {
    var t = e.target;
    if (pass || !t.matches || !t.matches(SEL)) return;
    e.stopImmediatePropagation();
    pending = t;
    say((t.checked ? 'Selected ' : 'Cleared ') + labelOf(t) + '. Press Apply filters to update the products.');
  }, true);

  // 2. apply on button press – replays the event so the theme renders with all current choices
  $(document).on('click.a11yFilter', '.a11y-filter-apply .btn', function () {
    if (!pending || !document.body.contains(pending)) { say('No filter changes to apply.'); return; }
    refocus = true;
    pass = true;
    pending.dispatchEvent(new Event('input', { bubbles: true }));
    pass = false;
    pending = null;
    say('Applying filters…');
  });

  // 3. announce the result once the theme has re-rendered the grid
  document.addEventListener('collection:reloaded', function () {
    ensureButtons();
    var n = $('#CollectionAjaxResult .grid-product, #CollectionAjaxContent .grid-product').filter(function () { return this.getClientRects().length; }).length
         || $('.grid-product').filter(function () { return this.getClientRects().length && !$(this).closest('#upezCartContainer').length; }).length;
    say('Filters applied. ' + n + (n === 1 ? ' product.' : ' products.'));
    if (refocus) {
      refocus = false;
      setTimeout(function () {
        var b = $('.a11y-filter-apply .btn').filter(function () { return this.getClientRects().length; }).get(0);
        if (b) b.focus();
      }, 100);
    }
  });

  console.log('[A11Y-FILTER-APPLY] filters applied only with the Apply filters button');
});


/* ==========================================================================
   FAQ-HEADINGS – FAQ page heading structure
   Place: ada-pro.js, at the very END of the file.
   Issue: the page has only one H1 ("Frequently Asked Questions"); the five
   category titles ("ABOUT AMERICAN BENCH CRAFT:", "PLACING ORDERS/SHIPPING:",
   "REPAIR/WARRANTY:", "CUSTOM WORK:", "OUR LEATHER:") are <p class="h2"> and
   the 20 questions are plain buttons, so screen reader users cannot jump
   between sections or questions with heading navigation (WCAG 1.3.1, 2.4.6).
   Fix: category titles become real <h2>, and each question button is wrapped
   in an <h3> (the WAI-ARIA accordion pattern: heading > button). Visual
   styling is unchanged.
   Result: H1 Frequently Asked Questions > H2 category > H3 question.
   ========================================================================== */
jQuery(function ($) {
  var $sec = $('.shopify-section').filter(function () { return /__faq(_|$)/.test(this.id) || $(this).find('.index-section--faq').length; });   // FAQ page + FAQ sections on other pages (e.g. Corporate Gifts)
  if (!$sec.length) return;

  $('<style id="a11y-faq-headings">' +
    'h3.a11y-faq-q{margin:0;padding:0;font:inherit;letter-spacing:inherit;text-transform:none;line-height:inherit}' +
    '</style>').appendTo('head');

  // 1. category titles <p class="h2"> -> <h2 class="h2">
  $sec.find('.index-section--faq p.h2').each(function () {
    var $h = $('<h2></h2>').attr('class', this.className).html(this.innerHTML);
    $(this).replaceWith($h);
  });

  // 2. question buttons -> <h3><button …></button></h3>
  $sec.find('button.collapsible-trigger').each(function () {
    if ($(this).parent().is('h3.a11y-faq-q')) return;
    $(this).wrap('<h3 class="a11y-faq-q"></h3>');
    $(this).find('.collapsible-trigger__icon').attr('aria-hidden', 'true');
  });

  console.log('[A11Y-FAQ-HEADINGS] FAQ categories = H2, questions = H3');
});

/* TEAM-PHOTO-ALT – Our Story page team photo has empty alt */
jQuery(function ($) {
  var ALT = 'The American Bench Craft team of eleven people in matching black company T-shirts and jeans, ' +
            'standing in a row on the grass in front of a brick wall painted with a faded American flag and ' +
            'the American Bench Craft logo reading "Leather goods and gear for any frontier, USA Made".';
  var $img = $('img[src*="Team_Photo_1920_x_1088"], img[srcset*="Team_Photo_1920_x_1088"]');
  $img.attr('alt', ALT);
  console.log('[A11Y-TEAM-PHOTO-ALT] alt set on', $img.length, 'image(s)');
});



/* ==========================================================================
   CONTACT-FORM – Contact page form (pages/contact)
   Place: ada-pro.js, at the very END of the file.
   Issues:
   - Required fields are not indicated (no "*", no instructions)      WCAG 3.3.2
   - Errors rely on the browser bubble (or nothing): not persistent,
     not linked to the field, not descriptive, focus not managed       WCAG 3.3.1, 3.3.3, 1.3.1
   - Phone has a pattern but no format instructions                     WCAG 3.3.2
   - After sending, the success / server error message is not
     announced and focus lands at the top of the page                   WCAG 4.1.3, 2.4.3
   Fix: required "*" (hidden from SR, field marked required) + instructions,
   autocomplete/inputmode, inline error under each field (aria-describedby +
   aria-invalid), an error summary that is announced, focus to the first
   field with an error, and an announced + focused success message.
   Required fields: edit REQUIRED below if the client wants a different set.
   ========================================================================== */
jQuery(function ($) {
  var $form = $('form.contact-form').filter(function () { return $(this).find('textarea[name="contact[body]"]').length; }).first();
  if (!$form.length) return;
  var form = $form[0];

  var REQUIRED = ['contact[name]', 'contact[email]', 'contact[body]'];        // Email + Message
  var FIELDS = {
    'contact[name]':  { label: 'Name',         ac: 'name',  im: null },
    'contact[email]': { label: 'Email',        ac: 'email', im: 'email' },
    'contact[phone]': { label: 'Phone number', ac: 'tel',   im: 'tel' },
    'contact[body]':  { label: 'Message',      ac: 'off',   im: null }
  };
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var PHONE = /^[0-9+()\-.\s]{7,}$/;

  // ---------- styles ----------
  $('<style id="a11y-contact-css">' +
    '.a11y-req{color:#a4161a;margin-left:2px}' +
    '.a11y-cf-hint{margin:0 0 16px;font-size:.95em}' +
    '.a11y-cf-error{display:block;margin:6px 0 14px;color:#a4161a;font-size:.9em}' +
    '.a11y-cf-help{display:block;margin:0 0 6px;font-size:.9em}' +
    '.contact-form [aria-invalid="true"]{border:2px solid #a4161a!important}' +
    '.a11y-cf-summary{border:2px solid #a4161a;padding:12px 16px;margin:0 0 20px}' +
    '.a11y-cf-summary h2{font-size:1.05em;margin:0 0 6px}' +
    '.a11y-cf-summary ul{margin:0;padding-left:18px}' +
    '.a11y-cf-summary a{color:#a4161a;text-decoration:underline}' +
    '.a11y-cf-success{border:2px solid #1b6e3a;padding:12px 16px;margin:0 0 20px;color:#1b6e3a}' +
    '.a11y-cf-summary:focus,.a11y-cf-success:focus{outline:3px solid #1c1d1d;outline-offset:3px}' +
    '</style>').appendTo('head');

  // ---------- labels, required, autocomplete ----------
  $form.attr('novalidate', 'novalidate');
  if (!$form.find('.a11y-cf-hint').length) {
    $form.prepend('<p class="a11y-cf-hint" id="a11y-cf-hint">Fields marked with an asterisk (<span aria-hidden="true">*</span><span class="visually-hidden">star</span>) are required.</p>');
  }
  $.each(FIELDS, function (name, cfg) {
    var el = form.querySelector('[name="' + name + '"]'); if (!el) return;
    el.setAttribute('autocomplete', cfg.ac);
    if (cfg.im) el.setAttribute('inputmode', cfg.im);
    var lab = el.labels && el.labels[0];
    var req = REQUIRED.indexOf(name) > -1;
    if (req) {
      el.setAttribute('required', 'required');
      el.setAttribute('aria-required', 'true');
      if (lab && !$(lab).find('.a11y-req').length) $(lab).append('<span class="a11y-req" aria-hidden="true">*</span>');
    } else {
      el.removeAttribute('required'); el.removeAttribute('aria-required');
    }
    if (name === 'contact[phone]') {
      el.removeAttribute('pattern');                         // we validate with a friendlier rule + message
      var hintId = el.id + '-hint';
      if (!document.getElementById(hintId)) {
        $(el).before('<span class="a11y-cf-help" id="' + hintId + '">Optional. Numbers, spaces, dashes and + only, for example 555-123-4567.</span>');
      }
      el.setAttribute('aria-describedby', hintId);
    }
  });

  // ---------- validation ----------
  function errId(el) { return el.id + '-error'; }
  function setError(el, msg) {
    var id = errId(el), $e = $('#' + $.escapeSelector(id));
    if (!$e.length) $e = $('<span class="a11y-cf-error"></span>').attr('id', id).insertAfter(el);
    $e.text('Error: ' + msg);
    el.setAttribute('aria-invalid', 'true');
    var d = (el.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== id; });
    d.unshift(id);
    el.setAttribute('aria-describedby', d.join(' '));
  }
  function clearError(el) {
    var id = errId(el);
    $('#' + $.escapeSelector(id)).remove();
    el.removeAttribute('aria-invalid');
    var d = (el.getAttribute('aria-describedby') || '').split(' ').filter(function (x) { return x && x !== id; });
    d.length ? el.setAttribute('aria-describedby', d.join(' ')) : el.removeAttribute('aria-describedby');
  }
  function check(el) {
    var v = $.trim(el.value), name = el.name, cfg = FIELDS[name] || { label: name };
    if (REQUIRED.indexOf(name) > -1 && !v) return 'Enter your ' + cfg.label.toLowerCase() + '.';
    if (name === 'contact[email]' && v && !EMAIL.test(v)) return 'Enter a valid email address, for example name@example.com.';
    if (name === 'contact[phone]' && v && !PHONE.test(v)) return 'Enter a valid phone number using numbers, spaces, dashes or +, for example 555-123-4567.';
    return '';
  }

  function summary(errors) {
    $form.find('.a11y-cf-summary').remove();
    if (!errors.length) return null;
    var $s = $('<div class="a11y-cf-summary" role="alert" tabindex="-1"><h2>' +
      (errors.length === 1 ? 'There is 1 error in the form' : 'There are ' + errors.length + ' errors in the form') +
      '</h2><ul></ul></div>');
    errors.forEach(function (x) {
      $('<li><a></a></li>').find('a').attr('href', '#' + x.el.id).text(x.msg).end().appendTo($s.find('ul'));
    });
    $s.on('click', 'a', function (e) { e.preventDefault(); var t = document.getElementById(this.getAttribute('href').slice(1)); if (t) t.focus(); });
    $form.prepend($s);
    return $s;
  }

  // capture phase on window: runs before Shopify's hCaptcha submit handler
  window.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var errors = [];
    $.each(FIELDS, function (name) {
      var el = form.querySelector('[name="' + name + '"]'); if (!el) return;
      var msg = check(el);
      if (msg) { setError(el, msg); errors.push({ el: el, msg: msg }); } else clearError(el);
    });
    if (errors.length) {
      e.preventDefault(); e.stopImmediatePropagation();
      summary(errors);                                         // role=alert -> announced
      errors[0].el.focus();                                    // focus first field with an error
    } else {
      $form.find('.a11y-cf-summary').remove();
    }
  }, true);

  // live clearing once the field becomes valid
  $form.on('input.a11yCf blur.a11yCf', 'input, textarea', function (e) {
    if (!this.hasAttribute('aria-invalid') && e.type === 'input') return;
    var msg = check(this);
    if (!msg) clearError(this); else if (e.type === 'blur' && this.hasAttribute('aria-invalid')) setError(this, msg);
  });

  // ---------- after the page reloads with the server result ----------
  var q = location.search, hash = location.hash;
  var cameBack = /contact_posted=true/.test(q) || (form.id && hash === '#' + form.id);
  if (cameBack) {
    var $scope = $form.add($form.parent());
    var $ok = $scope.find('.note--success, .form-success, .form-message--success').first();
    var $bad = $scope.find('.errors, .note--error, .form-error, .form-message--error').first();
    if (/contact_posted=true/.test(q) || $ok.length) {
      if (!$ok.length) $ok = $('<p></p>').text('Thanks for contacting us. We received your message and will get back to you as soon as possible.').insertBefore($form);
      $ok.addClass('a11y-cf-success').attr({ role: 'status', tabindex: '-1' });
      setTimeout(function () { $ok[0].scrollIntoView({ block: 'center' }); $ok.trigger('focus'); }, 300);
    } else if ($bad.length) {
      var txt = $.trim($bad.text()).replace(/\s+/g, ' ');
      $bad.attr('aria-hidden', 'true').hide();
      var el = form.querySelector('[name="contact[email]"]');
      setTimeout(function () {
        if (/email/i.test(txt) && el) setError(el, 'Enter a valid email address, for example name@example.com.');
        var $s = summary([{ el: el || form.querySelector('input,textarea'), msg: txt || 'Your message could not be sent. Check the form and try again.' }]);
        if ($s) { $s[0].scrollIntoView({ block: 'center' }); $s.trigger('focus'); }
      }, 300);
    }
  }

  console.log('[A11Y-CONTACT-FORM] contact form: required markers, autocomplete, errors, announcements, focus');
});







/* ==========================================================================
   American Bench Craft – accessibility remediation for A11Y-135 … A11Y-157
   Theme: Motion 10.3.1 ("ADA – 2/12/26 Duplicate Copy Sep 14")
   Load AFTER jQuery and after the existing a11y.js (uses window.announce if present).
   Each block is self-contained and guarded, so it can be shipped in parts.
   ========================================================================== */
(function ($) {
  'use strict';
  if (!$) { return; }

  /* ---------- shared helpers ---------------------------------------------- */
  var SEL_FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  // Reuse the announcer shipped with A11Y-098; create it if this file loads first.
  if (typeof window.announce !== 'function') {
    if (!document.getElementById('a11y-announcer')) {
      $('body').append('<div id="a11y-announcer" role="status" aria-live="polite" aria-atomic="true" class="visually-hidden"></div>');
    }
    window.announce = function (msg) {
      var $a = $('#a11y-announcer');
      $a.text('');
      setTimeout(function () { $a.text(msg); }, 100);
    };
  }

  function isVisible(el) {
    if (!el) { return false; }
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || cs.opacity === '0') { return false; }
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }

  function productHandle() {
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : '';
  }

  /* ========================================================================
     A11Y-135  Add to cart never completes (UpCart/"upez" loader swallows the
     submit). Watchdog: if the loader is still showing 8 s after activation and
     the cart count has not changed, post to /cart/add.js ourselves, then open
     the drawer. Enter/Space also made explicit for the button.
     Root cause lives in the UpCart app binding – this is the CDN-side safety net.
     ====================================================================== */
  (function fixAddToCart() {
    var $form = $('form[action*="/cart/add"]').first();
    var $btn = $form.find('button[name="add"], .add-to-cart').first();
    if (!$form.length || !$btn.length) { return; }

    var TIMEOUT = 8000;
    var $status = $('#a11y-atc-status');
    if (!$status.length) {
      $status = $('<div id="a11y-atc-status" role="alert" class="visually-hidden"></div>').insertAfter($btn);
    }

    function cartCount() {
      return $.getJSON('/cart.js').then(function (c) { return c.item_count; });
    }

    function restoreButton() {
      $btn.removeClass('with-upez-loader is-loading btn--loading').prop('disabled', false).attr('aria-busy', 'false');
    }

    function directAdd() {
      var data = $form.serialize();
      return $.ajax({ type: 'POST', url: '/cart/add.js', data: data, dataType: 'json' });
    }

    function openDrawer() {
      // Header cart control is the proven path (A11Y-007/008) – reuse it.
      var $trigger = $('a[href*="/cart"].js-drawer-open, [aria-controls="CartDrawer"]').filter(function () { return isVisible(this); }).first();
      if ($trigger.length) { $trigger.trigger('click'); }
    }

    $btn.on('keydown.a11y135', function (e) {
      if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });

    $btn.on('click.a11y135', function () {
      var $b = $(this);
      $b.attr('aria-busy', 'true');
      $status.text('');
      cartCount().then(function (before) {
        setTimeout(function () {
          cartCount().then(function (after) {
            if (after > before) {
              // The app finished – nothing to do. Make sure the state is clean.
              restoreButton();
              return;
            }
            if (!$b.hasClass('with-upez-loader') && !$b.attr('aria-busy')) { return; }
            // Stuck. Take over.
            directAdd().done(function (item) {
              restoreButton();
              var name = (item && item.product_title) || $('h1').first().text().trim();
              window.announce(name + ' added to cart.');
              openDrawer();
            }).fail(function (xhr) {
              restoreButton();
              var msg = (xhr.responseJSON && (xhr.responseJSON.description || xhr.responseJSON.message)) || 'Sorry, this item could not be added to the cart. Please try again.';
              $status.removeClass('visually-hidden').addClass('form-message form-message--error').text(msg).attr('tabindex', '-1').trigger('focus');
            });
          });
        }, TIMEOUT);
      });
    });
  })();

  /* ========================================================================
     A11Y-136  Search results page – search field has no accessible name.
     ====================================================================== */
  (function fixSearchFieldLabel() {
    $('form[role="search"], form[action="/search"]').each(function () {
      var $input = $(this).find('input[name="q"]');
      if (!$input.length) { return; }
      var id = $input.attr('id');
      if (!id) { id = 'a11y-search-q-' + Math.random().toString(36).slice(2, 7); $input.attr('id', id); }
      if (!$('label[for="' + id + '"]').length && !$input.attr('aria-label') && !$input.attr('aria-labelledby')) {
        $('<label class="visually-hidden" for="' + id + '">Search</label>').insertBefore($input);
      }
    });
  })();

  /* ========================================================================
     A11Y-137  Create Account form – autocomplete, required, error handling.
     Prefer the Liquid change in templates/customers/register.liquid (see notes);
     this patch gives the same result on first paint of the DOM-ready pass.
     ====================================================================== */
  (function fixRegisterForm() {
    var $form = $('#create_customer, form[action="/account"]').first();
    if (!$form.length) { return; }

    var map = {
      'customer[first_name]': { ac: 'given-name', req: true },
      'customer[last_name]':  { ac: 'family-name', req: true },
      'customer[email]':      { ac: 'email', req: true },
      'customer[password]':   { ac: 'new-password', req: true }
    };
    $.each(map, function (name, cfg) {
      var $i = $form.find('[name="' + name + '"]');
      if (!$i.length) { return; }
      $i.attr('autocomplete', cfg.ac);
      if (cfg.req) {
        $i.attr({ required: 'required', 'aria-required': 'true' });
        var $l = $('label[for="' + $i.attr('id') + '"]');
        if ($l.length && !/\*/.test($l.text())) {
          $l.append(' <span aria-hidden="true">*</span><span class="visually-hidden"> (required)</span>');
        }
      }
    });
    // Password requirements (Shopify minimum is 5 characters)
    var $pwd = $form.find('[name="customer[password]"]');
    if ($pwd.length && !$pwd.attr('aria-describedby')) {
      $('<p id="a11y-pwd-hint" class="form__hint">Password must be at least 5 characters.</p>').insertAfter($pwd);
      $pwd.attr('aria-describedby', 'a11y-pwd-hint');
    }
    if (!$form.find('.a11y-required-legend').length) {
      $form.prepend('<p class="a11y-required-legend">Fields marked <span aria-hidden="true">*</span><span class="visually-hidden">asterisk</span> are required.</p>');
    }
    // Server-side errors (Shopify re-renders the page with .errors)
    var $err = $form.find('.errors, .form-message--error, [data-form-errors]').first();
    if ($err.length && $.trim($err.text())) {
      $err.attr({ role: 'alert', tabindex: '-1', id: $err.attr('id') || 'a11y-register-errors' });
      // Associate with the field the message names
      var txt = $err.text().toLowerCase();
      $.each({ email: 'customer[email]', password: 'customer[password]', 'first name': 'customer[first_name]', 'last name': 'customer[last_name]' }, function (word, name) {
        if (txt.indexOf(word) > -1) { $form.find('[name="' + name + '"]').attr({ 'aria-invalid': 'true', 'aria-describedby': $err.attr('id') }); }
      });
      setTimeout(function () { $err.trigger('focus'); }, 50);
    }
  })();

  /* ========================================================================
     A11Y-138  404 page – "Popular picks" renders placeholder "Example product"
     cards. Real fix = assign a collection in the theme editor (see notes).
     Fallback: hide the section until it is configured.
     ====================================================================== */
  (function hide404Placeholders() {
    if (!$('body').hasClass('template-404')) { return; }
    $('.grid-product').filter(function () {
      return /^example product$/i.test($.trim($(this).find('.grid-product__title, .grid-product__link').first().text()));
    }).closest('[id^="shopify-section-"]').each(function () {
      if ($(this).find('.grid-product').length === $(this).find('.grid-product').filter(function () { return /example product/i.test($(this).text()); }).length) {
        $(this).hide().attr('aria-hidden', 'true');
      }
    });
  })();

  /* ========================================================================
     A11Y-139  Bracelet size guide image has alt="" and no text equivalent.
     TODO (client): replace the measurement text below with the values printed
     on Bracelets_Size_Guide_2.png before shipping.
     ====================================================================== */
  (function braceletSizeGuide() {
    var $img = $('img[src*="Bracelets_Size_Guide"], img[data-src*="Bracelets_Size_Guide"]').first();
    if (!$img.length || $img.next('.a11y-size-guide-text').length) { return; }
    $img.attr('alt', 'Bracelet size guide');
    var html = '<div class="a11y-size-guide-text">' +
      '<p><strong>Bracelet size guide.</strong> Measure your wrist snugly with a soft tape measure where you will wear the bracelet. ' +
      'Small fits wrists 6 to 6.5 inches, Medium fits 6.5 to 7.25 inches, Large fits 7.25 to 8 inches. ' +
      'If you are between sizes, choose the larger size.</p></div>'; // <-- confirm these ranges against the graphic
    var $wrap = $img.closest('a').length ? $img.closest('a') : $img;
    $wrap.after(html);
  })();

  /* ========================================================================
     A11Y-140  Brass-plate engraving field labelled "Line 1 (24 Characters) *".
     Also closes A11Y-050 (hunting collar line 1) with the same map.
     ====================================================================== */
  (function relabelPersonalizationFields() {
    var byHandle = {
      'gentlemans-belt':                { 'product-options-custom-1': 'Brass plate engraving text' },
      'personalized-hunting-collar':    { 'product-options-custom-1': 'Dog name' },
      'personalized-small-dog-collar':  { 'product-options-custom-1': 'Dog name' },
      'personalized-martingale-collar': { 'product-options-custom-1': 'Dog name' },
      'personalized-standard-collar':   { 'product-options-custom-1': 'Dog name' }
    };
    var map = byHandle[productHandle()];
    if (!map) { return; }
    $.each(map, function (id, text) {
      var $l = $('label[for="' + id + '"]');
      if (!$l.length) { return; }
      // Replace only the leading "Line N (24 Characters)" text node, keep counter/asterisk.
      $l.contents().each(function () {
        if (this.nodeType === 3 && /Line \d+ \(\d+ Characters\)/.test(this.nodeValue)) {
          this.nodeValue = this.nodeValue.replace(/Line \d+ \((\d+) Characters\)/, text + ' (up to $1 characters)');
        }
      });
    });
  })();

  /* ========================================================================
     A11Y-141  "Personalize It" select reveals a required Initials field with no
     announcement / relationship; price change not communicated.
     ====================================================================== */
  (function personalizeItReveal() {
    $('select.js-cust-prod-options-upsell, select[id^="product-options-custom"]').each(function () {
      var $sel = $(this);
      var $wrap = $('#' + $sel.attr('id') + '-conditional, [id^="' + $sel.attr('id') + '-condi"]').first();
      if (!$wrap.length) {
        // Conditional field shares the id prefix; find its input and use the nearest wrapper.
        var $cond = $('input[id^="' + $sel.attr('id') + '-condi"]').first();
        if (!$cond.length) { return; }
        $wrap = $cond.closest('div');
        if (!$wrap.attr('id')) { $wrap.attr('id', $sel.attr('id') + '-conditional-wrap'); }
      }
      $sel.attr('aria-controls', $wrap.attr('id'));
      function sync(announceIt) {
        var open = isVisible($wrap[0]);
        $sel.attr('aria-expanded', open ? 'true' : 'false');
        if (!announceIt) { return; }
        if (open) {
          var $input = $wrap.find('input,textarea').first();
          var label = $.trim($('label[for="' + $input.attr('id') + '"]').text().replace(/\d+\s*\|\s*\d+/, ''));
          var price = ($sel.find('option:selected').text().match(/\[\+\s*([^\]]+)\]/) || [])[1];
          window.announce(label + ' field added, required.' + (price ? ' Adds ' + price + ' to the price.' : ''));
          setTimeout(function () { $input.trigger('focus'); }, 150);
        } else {
          window.announce('Personalization removed.');
        }
      }
      sync(false);
      $sel.on('change.a11y141', function () { setTimeout(function () { sync(true); }, 300); });
    });
  })();

  /* ========================================================================
     A11Y-142  Character counter ("0 | 24") lives inside the <label>.
     Move it out, link it with aria-describedby, make it a polite status.
     ====================================================================== */
  (function moveCharCounters() {
    $('label').each(function () {
      var $l = $(this);
      var inputId = $l.attr('for');
      if (!inputId) { return; }
      var $counter = $l.find('*').filter(function () { return /^\s*\d+\s*\|\s*\d+\s*$/.test($(this).text()); }).last();
      if (!$counter.length) { return; }
      var cid = inputId + '-count';
      $counter.attr({ id: cid, role: 'status', 'aria-live': 'polite', 'aria-atomic': 'true' }).insertAfter($('#' + inputId));
      var $i = $('#' + inputId);
      var db = ($i.attr('aria-describedby') || '').split(/\s+/).filter(Boolean);
      if (db.indexOf(cid) === -1) { db.push(cid); }
      $i.attr('aria-describedby', db.join(' '));
      // Debounce the live announcements so each keystroke is not spoken.
      var t;
      $i.on('input.a11y142', function () {
        $counter.attr('aria-live', 'off');
        clearTimeout(t);
        t = setTimeout(function () { $counter.attr('aria-live', 'polite'); }, 1200);
      });
    });
  })();

  /* ========================================================================
     A11Y-143 (+ A11Y-041 / A11Y-101)  Gallery thumbnail strip:
       - off-screen thumbnails leave the tab order,
       - arrow keys move between thumbnails,
       - focus is not dropped to <body> after a thumbnail is selected.
     ====================================================================== */
  // (function fixThumbnailStrip() {
  //   var $items = $('.product__thumb-item a');
  //   if (!$items.length) { return; }

  //   function visibleInStrip(el) {
  //     var r = el.getBoundingClientRect();
  //     var strip = el.closest('.flickity-viewport, .product__thumbs');
  //     if (!strip) { return isVisible(el); }
  //     var s = strip.getBoundingClientRect();
  //     return r.width > 0 && r.bottom > s.top + 1 && r.top < s.bottom - 1 && r.right > s.left + 1 && r.left < s.right - 1;
  //   }

  //   function syncTabOrder() {
  //     $('.product__thumb-item a').each(function () {
  //       $(this).attr('tabindex', visibleInStrip(this) ? '0' : '-1');
  //     });
  //   }
  //   syncTabOrder();

  //   var $strip = $items.first().closest('.flickity-enabled');
  //   if ($strip.length) {
  //     $strip.on('settle.flickity change.flickity ready.flickity', syncTabOrder);
  //     if (window.Flickity && Flickity.data($strip[0])) {
  //       Flickity.data($strip[0]).on('settle', syncTabOrder);
  //     }
  //   }
  //   $(window).on('resize.a11y143', syncTabOrder);

  //   // Arrow-key navigation + keep focus on the selected thumbnail.
  //   $(document).on('keydown.a11y143', '.product__thumb-item a', function (e) {
  //     var $all = $('.product__thumb-item a');
  //     var i = $all.index(this);
  //     var next = null;
  //     if (e.key === 'ArrowRight' || e.key === 'ArrowDown') { next = $all.eq(Math.min(i + 1, $all.length - 1)); }
  //     if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') { next = $all.eq(Math.max(i - 1, 0)); }
  //     if (e.key === 'Home') { next = $all.first(); }
  //     if (e.key === 'End') { next = $all.last(); }
  //     if (next) {
  //       e.preventDefault();
  //       next.attr('tabindex', '0')[0].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  //       next.trigger('focus').trigger('click');
  //     }
  //   });

  //   // The theme re-renders the slider on thumbnail selection and loses focus (A11Y-041).
  //   $(document).on('click.a11y143', '.product__thumb-item a', function () {
  //     var el = this;
  //     setTimeout(function () {
  //       if (document.activeElement === document.body && document.contains(el)) {
  //         el.setAttribute('tabindex', '0');
  //         el.focus({ preventScroll: true });
  //       }
  //     }, 60);
  //   });
  // })();

  /* ========================================================================
     A11Y-144  Gallery slides with alt="". Positional fallback – real alt text
     should be authored in Shopify admin > Products > Media.
     ====================================================================== */
  (function gallerySlideAlt() {
    var title = $.trim($('.product-single__title, h1').first().text());
    var $imgs = $('.product__photos img, .product-slideshow img');
    var n = $imgs.length;
    $imgs.each(function (i) {
      if (!$.trim($(this).attr('alt') || '')) {
        $(this).attr('alt', title + ' – image ' + (i + 1) + ' of ' + n);
      }
    });
  })();

  /* ========================================================================
     A11Y-145  Generic / filename alt text on informative images.
     Extend the map as admin alts are fixed; filename keys are matched on src.
     ====================================================================== */
  (function altTextMap() {
    var byAlt = {
      'Product Badges': 'Made in USA, Bench Craft Guarantee, Premium Full Grain Leather',
      'Corporate Gift Slider Photo': 'Leather corporate gifts with custom logos: belts, wallets and key fobs'
    };
    var bySrc = {
      'MonogramInfograph-HammerRivetedWallet': 'Monogram placement on the Hammer Riveted Wallet: up to five initials heat-embossed in the lower right corner of the front panel',
      'Monogram_Infograph_-_Working_Man_s_Belt': 'Monogram placement on the Working Man\'s Belt: up to five initials heat-embossed on the tail end of the belt'
    };
    $('img').each(function () {
      var alt = $.trim($(this).attr('alt') || '');
      var src = ($(this).attr('src') || $(this).attr('data-src') || '');
      if (byAlt[alt]) { $(this).attr('alt', byAlt[alt]); return; }
      $.each(bySrc, function (key, text) {
        if (src.indexOf(key) > -1 || alt === key) { $(this).attr('alt', text); }
      }.bind(this));
    });
  })();

  /* ========================================================================
     A11Y-146  Empty headings (e.g. empty <h3> in the Hunting Dog Collar
     description). Remove any heading with no text and no image alt.
     ====================================================================== */
  (function removeEmptyHeadings() {
    $('h1,h2,h3,h4,h5,h6').filter(function () {
      return !$.trim($(this).text()) && !$(this).find('img[alt]').filter(function () { return $.trim(this.alt); }).length;
    }).remove();
  })();

  /* ========================================================================
     A11Y-147  Register Your Product page – H1 > H3 skip; Name required per
     the instructions but not marked.
     A11Y-148  Military Discounts – section title not a heading; H3 names
     without an H2.
     A11Y-149  Junip review titles rendered as <h4> directly under H1/H2.
     Shared helper: swap a heading's level while keeping classes/content.
     ====================================================================== */
  function setHeadingLevel($h, level) {
    $h.each(function () {
      if (this.tagName.toLowerCase() === 'h' + level) { return; }
      var $new = $('<h' + level + '>').attr('class', this.className).html($(this).html());
      $.each(this.attributes, function () { if (this.name !== 'class') { $new.attr(this.name, this.value); } });
      $(this).replaceWith($new);
    });
  }

  (function fixRegisterPage() {
    if (window.location.pathname !== '/pages/register') { return; }
    setHeadingLevel($('#MainContent h3').filter(function () { return /fill out the form/i.test($(this).text()); }), 2);
    var $name = $('input[name="contact[name]"]');
    if ($name.length) {
      $name.attr({ required: 'required', 'aria-required': 'true' });
      var $l = $('label[for="' + $name.attr('id') + '"]');
      if ($l.length && !/\*/.test($l.text())) { $l.append('<span aria-hidden="true">*</span><span class="visually-hidden"> (required)</span>'); }
    }
  })();

  (function fixMilitaryPage() {
    if (window.location.pathname !== '/pages/military-discounts') { return; }
    // "HOW TO RECEIVE YOUR DISCOUNT" – styled text -> h2
    $('#MainContent p, #MainContent div, #MainContent span').filter(function () {
      return $(this).children().length === 0 && /^how to receive your discount/i.test($.trim($(this).text()));
    }).first().replaceWith(function () { return '<h2 class="' + this.className + '">' + $(this).html() + '</h2>'; });
    // Testimonial names are h3 with no h2 above them – insert a section heading once.
    var $firstName = $('#MainContent h3').first();
    if ($firstName.length && !$firstName.prevAll('h2').length && !$('#a11y-stories-heading').length) {
      var $section = $firstName.closest('[id^="shopify-section-"], section, .page-width');
      ($section.length ? $section : $firstName.parent()).prepend('<h2 id="a11y-stories-heading" class="visually-hidden">What our military and first responder customers say</h2>');
    }
  })();

  (function fixJunipHeadings() {
    var level = window.location.pathname === '/pages/reviews' ? 2 : 3;
    function run() {
      var $titles = $('.junip-review-title, h4[class*="junip"]');
      if ($titles.length) { setHeadingLevel($titles, level); }
      // Reviews page: give the review list a parent heading if the page only has an H1
      if (level === 2 && !$('#MainContent h2').length && $('.junip-review-title').length && !$('#a11y-reviews-heading').length) {
        $('.junip-reviews, [class*="junip-review-list"]').first().before('<h2 id="a11y-reviews-heading" class="visually-hidden">Customer reviews</h2>');
      }
    }
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
  })();

  /* ========================================================================
     A11Y-150  Article table has a caption but no <th>. First row -> column
     headers; first column -> row headers when the table is a comparison grid.
     Author the HTML properly in Shopify admin; this is the fallback.
     ====================================================================== */
  (function articleTableHeaders() {
    $('article table, .rte table, .article__body table').each(function () {
      var $t = $(this);
      if ($t.find('th').length) { return; }
      var $rows = $t.find('tr');
      $rows.first().find('td').replaceWith(function () { return '<th scope="col">' + $(this).html() + '</th>'; });
      $rows.slice(1).each(function () {
        $(this).find('td').first().replaceWith(function () { return '<th scope="row">' + $(this).html() + '</th>'; });
      });
      if (!$t.find('thead').length) { $t.prepend($('<thead>').append($t.find('tr').first())); }
    });
  })();

  /* ========================================================================
     A11Y-151 / A11Y-152  Target sizes – see a11y-remediation-135-157.css.
     Nothing to do in JS.
     ====================================================================== */

  /* ========================================================================
     A11Y-153  Klaviyo teaser: unnamed role=button; overlaps open drawers.
     Klaviyo re-renders, so run on mutation. Hiding while a drawer is open is CSS.
     ====================================================================== */
  (function klaviyoTeaser() {
    function run() {
      $('[class*="Teaser"][role="button"], .klaviyo-form-teaser [role="button"]').each(function () {
        if (!$(this).attr('aria-label')) {
          var txt = $.trim($(this).text()) || '10% off';
          $(this).attr('aria-label', 'Open sign-up form, ' + txt);
        }
      });
    }
    run();
    new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
    // Mark the body while any theme drawer / dialog is open so CSS can hide the teaser.
    function syncDrawerState() {
      var open = $('.drawer.is-active, .js-drawer-open, [role="dialog"][aria-modal="true"]').filter(function () { return isVisible(this); }).length > 0;
      $('body').toggleClass('a11y-dialog-open', open);
    }
    new MutationObserver(syncDrawerState).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
    syncDrawerState();
  })();

  /* ========================================================================
     A11Y-154  Identical "YouTube video player" iframe titles.
     Map by video id; falls back to the nearest preceding heading.
     ====================================================================== */
  (function youtubeTitles() {
    var byId = {
      'UqM7OuF58us': 'Video: Top Selling Leather Multi-Tool Case',
      'vEaIq55eL_g': 'Video: American Bench Craft - Our Story'
    }; // <-- confirm titles against the actual videos
    $('iframe[src*="youtube.com/embed/"]').each(function () {
      var id = (this.src.match(/embed\/([^?&\/]+)/) || [])[1];
      var title = byId[id];
      if (!title) {
        var $h = $(this).prevAll('h2,h3').first();
        title = 'Video: ' + ($h.length ? $.trim($h.text()) : 'YouTube video ' + ($('iframe[src*="youtube.com/embed/"]').index(this) + 1));
      }
      $(this).attr('title', title);
    });
  })();

  /* ========================================================================
     A11Y-155  mailto/tel labels must match the visible text (2.5.3).
     Derive the label from the href instead of hard-coding it.
     ====================================================================== */
  (function contactLinkLabels() {
    $('a[href^="mailto:"]').each(function () {
      var addr = this.getAttribute('href').replace(/^mailto:/i, '').split('?')[0];
      $(this).attr('aria-label', 'Email Address: ' + addr);
    });
    $('a[href^="tel:"]').each(function () {
      var visible = $.trim($(this).text()).replace(/\.$/, '');
      $(this).attr('aria-label', 'Phone Number: ' + visible);
    });
  })();

  /* ========================================================================
     A11Y-156  Testimonial star ratings are plain ★ characters.
     ====================================================================== */
  (function testimonialStars() {
    $('.testimonial-stars').each(function () {
      var filled = ($(this).text().match(/★/g) || []).length;
      var total = ($(this).text().match(/[★☆]/g) || []).length || 5;
      $(this).attr({ role: 'img', 'aria-label': 'Rated ' + filled + ' out of ' + total + ' stars' });
    });
  })();

  /* ========================================================================
     A11Y-157  Accessibility statement – content task (see notes). This only
     adds the footer link once the page exists, so nothing 404s meanwhile.
     ====================================================================== */
  (function accessibilityStatementLink() {
    var $support = $('footer a[href="/pages/contact"]').closest('ul');
    if (!$support.length || $('footer a[href="/pages/accessibility-statement"]').length) { return; }
    $.ajax({ type: 'HEAD', url: '/pages/accessibility-statement' }).done(function () {
      $support.append('<li><a href="/pages/accessibility-statement" class="' + ($support.find('a').first().attr('class') || '') + '">Accessibility Statement</a></li>');
    });
  })();

})(window.jQuery);







